import apiUrl from '../../../../constants'
import commonFunction from '../../../../commonFunction'
import constantVariable from '../../../../constantVariable'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Vue from 'vue';
import { AES, enc } from 'crypto-js';
import Loading from 'vue-loading-overlay';
import paginate from 'vuejs-paginate';

import {
    Chart
} from 'highcharts-vue';
import {
    BasicSelect
} from 'vue-search-select';
import Highcharts, {
    arrayMin
} from 'highcharts'
import highchartsMore from 'highcharts/highcharts-more';
import solidGauge from 'highcharts/modules/solid-gauge';

Vue.filter('formatDatesingle', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY hh:mm:ss')
  }
});

highchartsMore(Highcharts);
solidGauge(Highcharts);

export default {
    name: 'b2bdashboard',
    components: {
        Loading,
        highcharts: Chart,
        BasicSelect,
        paginate
    },

    data() {
        return {
            b2btrackShipmentAccess:true,
            Enquirymodal: false,
            Requestmodal: false,
            complaintmodal: false,
            Escalationmodal: false,
            pageno: 0,
            pagecount: 0,
            ticketname: '',
            type: '',
            hub: '',
            deptidBulk:'',
            useridBulk:'',
            filter: '',
            fullPage: false,
            isLoading: false,
            isLoadingInboundCallsTrend: false,
            isLoadingTopLocationsComplaint: false,
            isLoadingInboundCallsFibucation: false,
            isLoadingTopLocationsEscalation: false,
            isLoadingTopInboundContactMTD: false,
            isLoadingPagination: false,
            isLoadingTopInboundContact: false,
            isLoadingTwitterTickets: false,
            isLoadingOutboundContactTodayPerformance: false,
            isLoadingOutboundContactMTDPerformance: false,
            isLoadingAutoIVRCallLine: false,
            isLoadingNDRCallSummary: false,
            isLoadingAutoIVRCallTable: false,
            isLoadingCancellationReasons: false,
            isLoadingOutboundContactFack: false,
            isLoadingOutBoundMTDContactCenterFack: false,
            CSAWStatusSummaryLoading: false,
            isLoadingNDRCallLineChart: false,
            InboundMainDiv: false,
            OutboundMainDiv: false,
            showTable: 0,
            InboundContactCenter: {
                CalledDate: '0',
                TotalCall: '0',
                UniqueNumbersTotalCalls: '0',
                CallTransferToCC: '0',
                TakenCareByIVR: '0',
                AnsweredByCC: '0',
                MissedCall: '0',
                MissedCallMTD: '0',
                QueueFull: '0',
                ChannelUnavailable: '0',
                HolidaySetting: '0',
                RepeatCalls: '0',
                RepeatCallsMTD: '0',
                AHT: '0',
                serviceLevel: '0',
                holdTime: '0',
                Esc: '0',
            },
            NDRCallSummary: {
                NDRCallSummaryElement: {
                    CallDate: '',
                    Dialed: '',
                    DownloadDate: '',
                    Ext: '',
                    Exten: '',
                    Failed: '',
                    Languages: '',
                    Missed: '',
                    NotDialed: '',
                    Success: '',
                    TotalDownload: ''
                },
                NDRCallSummaryData: [],
                DownloadedTotal: '0',
                SuccessTotal: '0',
                FailedTotal: '0',
                MissedTotal: '0',
                DialedTotal: '0',
                NotDialedTotal: '0',
                NDRCnt: ''
            },
            OutBoundContactCenter: {
                DownloadDate: '0',
                TotalDownload: '0',
                NotDialed: '0',
                Dialed: '0',
                Success: '0',
                Failed: '0',
                Missed: '0',
                AHT: '0',
                HoldTime: '0',
                serviceLevel: '0',
                Fake: '0'
            },
            OutBoundMTDContactCenter: {
                DownloadDate: '0',
                TotalDownload: '0',
                NotDialed: '0',
                Dialed: '0',
                Success: '0',
                Failed: '0',
                Missed: '0',
                AHT: '0',
                HoldTime: '0',
                serviceLevel: '0',
                Fake: '0'
            },
            AutoIVRCallSummary: {
                AutoIVRCallSummaryElement: {
                    Congestion: "0",
                    Dialed: "0",
                    Faild: "0",
                    HubZone: "-",
                    HungupByCustomer: "0",
                    Isbusy: "0",
                    Isringing: "0",
                    Pending: "0",
                    Success: "0",
                    TotalCalls: "0",
                    WrongNumber: "0",
                    Delivered: "0",
                    NotDelivered: "0",
                    NoResponce: "0",
                },
                AutoIVRCallSummaryData: [],
                AutoIVRCnt: '',
                DialerType: '1',
            },
            TicketsSummery: {
                TwitterTickets: {
                    TwitterTicket: [],
                    TwitterTicketEle: {
                        maintypeid: 0,
                        maintype: 0,
                        total_count: 0
                    }
                },
                Inquiry: {
                    InquiryObj: {
                        Name: '',
                        Values: '',
                        subResone: ''
                    },
                    InquiryData: [],
                    TotalCound: '0',
                    OtherCound: '0'
                },
                Request: {
                    RequestObj: {
                        Name: '',
                        Values: '',
                        subResone: ''
                    },
                    RequestData: [],
                    TotalCound: '0',
                    OtherCound: '0'
                },
                Complaint: {
                    ComplaintObj: {
                        Name: '',
                        Values: '',
                        subResone: ''
                    },
                    ComplaintData: [],
                    TotalCound: '0',
                    OtherCound: '0'
                },
                Escalation: {
                    EscalationObj: {
                        Name: '',
                        Values: '',
                        subResone: ''
                    },
                    EscalationData: [],
                    TotalCount: '0',
                    OtherCount: '0'
                },
                Ticketsummerymodal: false,
                TicketTypeName: '',
                TicketSummeryList: [],
                TicketSummeryListEel: {
                    shippingid: '',
                    ticketid: '',
                    pincode: '',
                    createddate: '',
                    ticketstatus: '',
                    reattemptdate: '',
                    reasonid: '',
                    sourceid: '',
                    subreasonid: ''
                },

                TopLocations: {
                    Toplocation: [],
                    Toplocationele: {
                        hub: '',
                        hubname: '',
                        total_count: ''
                    },
                    ToplocationCount: 0,
                    ToplocationEscalation: [],
                    ToplocationEscalationele: {
                        hub: '',
                        hubname: '',
                        total_count: ''
                    },
                    TopEscalationCount: 0
                }
            },
            chartLineOptions: {

                chart: {
                    type: 'line',
                    height: '300px'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                xAxis: {
                    title: {
                        text: 'Time Slot'
                    },
                    categories: []
                },
                yAxis: {
                    title: {
                        text: 'Number Of Calls'
                    }
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true
                        },
                        enableMouseTracking: true
                    }
                },
                series: []
            },
            NDRcallsLine: {
                chart: {
                    type: 'line',
                    height: '300px'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                xAxis: {
                    title: {
                        text: 'Time Slot'
                    },
                    categories: []
                },
                yAxis: {
                    title: {
                        text: 'Number Of Calls'
                    }
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true
                        },
                        enableMouseTracking: true
                    }
                },
                series: []
            },
            AutoIVRCallsLine: {
                chart: {
                    type: 'line',
                    height: '300px'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                xAxis: {
                    title: {
                        text: 'Time Slot'
                    },
                    categories: []
                },
                yAxis: {
                    title: {
                        text: 'Number Of Calls'
                    }
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true
                        },
                        enableMouseTracking: true
                    }
                },
                series: []
            },
            InboundcallsPie: {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie',
                    height: '300px',
                    margin: [0, 0, 0, 0]
                },
                title: {
                    text: null
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '{point.name}: <b>{point.y}</b>'
                        }
                    }
                },
                series: []

            },
            chartCSAWOptions: {
                chart: {
                    type: 'bar',
                    height: '300px'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: [''],
                    title: {
                        text: null
                    }
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    labels: {
                        enabled: false
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                series: [],
                totalcount: 0
            },
            MTDreatempt: {
                chart: {
                    type: 'solidgauge',
                    height: '140px',
                    margin: [0, 0, 0, 0]
                },
                title: null,
                pane: {
                    center: ['50%', '85%'],
                    size: '140%',
                    startAngle: -90,
                    endAngle: 90,
                    background: {
                        backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || '#EEE',
                        innerRadius: '60%',
                        outerRadius: '100%',
                        shape: 'arc'
                    }
                },

                tooltip: {
                    enabled: false
                },

                // the value axis
                yAxis: {
                    min: 0,
                    max: 100,
                    stops: [
                        [0.1, '#ff4500'], // red
                        [0.5, '#DDDF0D'], // yellow
                        [0.9, '#55BF3B'] // green
                    ],
                    lineWidth: 0,
                    minorTickInterval: null,
                    tickAmount: 1,
                    title: {
                        y: -70
                    },
                    labels: {
                        y: 16
                    }
                },
                plotOptions: {
                    solidgauge: {
                        dataLabels: {
                            y: 5,
                            borderWidth: 0,
                            useHTML: true
                        }
                    }
                },

                credits: {
                    enabled: false
                },
                series: [{
                    name: '',
                    data: [],
                    dataLabels: {
                        format: '<div style="text-align:center"><span style="font-size:25px;color:' +
                            ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">{y}%</span><br/>' +
                            '<span style="font-size:12px;color:silver"></span></div>'
                    },
                    tooltip: {
                        valueSuffix: 'MTD Reattempt Conversion'
                    }
                }]
            },
            MTDEscalation: {
                chart: {
                    type: 'solidgauge',
                    height: '140px',
                    margin: [0, 0, 0, 0]
                },
                title: null,
                pane: {
                    center: ['50%', '85%'],
                    size: '140%',
                    startAngle: -90,
                    endAngle: 90,
                    background: {
                        backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || '#EEE',
                        innerRadius: '60%',
                        outerRadius: '100%',
                        shape: 'arc'
                    }
                },

                tooltip: {
                    enabled: false
                },

                // the value axis
                yAxis: {
                    min: 0,
                    max: 100,
                    stops: [
                        [0.1, '#ff4500'], // red
                        [0.5, '#DDDF0D'], // yellow
                        [0.9, '#55BF3B'] // green
                    ],
                    lineWidth: 0,
                    minorTickInterval: null,
                    tickAmount: 2,
                    title: {
                        y: -70
                    },
                    labels: {
                        y: 16
                    }
                },

                plotOptions: {
                    solidgauge: {
                        dataLabels: {
                            y: 5,
                            borderWidth: 0,
                            useHTML: true
                        }
                    }
                },

                credits: {
                    enabled: false
                },
                series: [{
                    name: '',
                    data: [],
                    dataLabels: {
                        format: '<div style="text-align:center"><span style="font-size:25px;color:' +
                            ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">{y}%</span><br/>' +
                            '<span style="font-size:12px;color:silver"></span></div>'
                    },
                    tooltip: {
                        valueSuffix: 'MTD Escalation Conversion'
                    }
                }]
            },
            CancellationReasons: {
                chart: {
                    type: 'pie',
                    height: '300px'
                },
                title: null,
                yAxis: {
                    title: null
                },

                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,

                    }
                },
                legend: {
                    align: 'left',
                    layout: 'vertical',
                    verticalAlign: 'top',
                    y: 0,
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    formatter: function () {
                        return '<b>' + this.point.name + '</b>: ' + this.y;
                    }
                },
                series: [],
                totalCount: 0
            },
            AutoIVRSelectOptionArr: [{
                    value: '1',
                    text: 'CRA'
                },
                {
                    value: '2',
                    text: 'ODA'
                },
                {
                    value: '3',
                    text: 'HIGH VAlUE'
                }
            ],
            AutoIVRSelectOptionObj: {
                value: '2',
                text: 'ODA'
            },

            SummaryOptionObj: [],
            SummarySelectOptionObj: {
                value: '',
                text: ''
            },
            HubOptionObj: [],
            HubSelectOptionObj: {
                value: '',
                text: ''
            },
            HubNameDiv: false,
            FieldOperationId: 5,
            FwdClientSupport: 6,
            RvpClientSupport: 7,
            B2BClientSupport: 16,
            clientlistmodal: false,
            clientListButton: false,
            clientListSpan: false,
            clientlistObj: [],
            clientlistOptionObj: {
                value: '',
                text: ''
            },
            ticketSummeryListforBulkEdit:[],
            showEditBulkButton : false,
            userClientNameBulk : '',
            b2bEnquirymodal: false,
            b2bRequestmodal: false,
            b2bcomplaintmodal: false,
        }
    },
    created: async function () {
        await this.getSummaryType();
    },
    computed: {

    },
    mounted() {
        this.getTicketsSummery_Enquiry_Request_Complaint1() ;
        [this.subDepartmentList, this.DepartmentID,this.userdetail,this.permissiondata,this.userTypeForTicket, this.SummarySelectOptionObj, this.SummaryOptionObj]=commonFunction.getuserDetailsAndpermissionData();
        this.accessRestrictor();
        this.isLoadingTwitterTickets = true;
        this.isLoadingTopInboundContact = true;
        this.isLoadingInboundCallsTrend = false;
        this.isLoadingInboundCallsFibucation = true;
        this.isLoadingTopInboundContactMTD = true;
        this.isLoadingNDRCallSummary = true;
        this.isLoadingNDRCallLineChart = true;
        this.isLoadingAutoIVRCallLine = true;
        this.isLoadingAutoIVRCallTable = true;
        this.isLoadingOutboundContactTodayPerformance = true;
        this.isLoadingOutboundContactMTDPerformance = true;
        this.isLoadingOutBoundMTDContactCenterFack = true;
       // this.CSAWStatusSummaryLoading = true;  // Temporary Commented

        var userSubData = window.localStorage.getItem(
            "userSubDepartmentId"
        );
        var userSubResultdata = "";
        if (userSubData) {
            userSubResultdata = JSON.parse(userSubData);
            if (userSubResultdata.value == this.FieldOperationId) {
                this.HubNameDiv = true;
                this.getUserHubList();
            } else {
                this.HubNameDiv = false;
            }

            if (userSubResultdata.value == this.FwdClientSupport || userSubResultdata.value == this.RvpClientSupport) {
                this.clientListButton = true;
                this.clientList();
            } else {
                this.clientListButton = false;
                this.clientListSpan = false;
            }
        }
        if (this.InboundMainDiv) {
            this.getTwitterTickets();
            this.getIvrInboundSummeryDetails();
            this.getIvrInboundMTDSummeryDetails();
            this.getInboundLineChartData();
            this.getInboundCallEsc();
        }

        if (this.OutboundMainDiv) {
            this.getOutBoundCallingFlashData();
            this.getFakeResoneTicket();
            this.getNDRCallSummary();
            this.getOutBoundMTDCallingFlashData();
            this.getAutoIVRCallSummary('2');
            this.getMTDFakeResoneTicket();
        }
    },
    methods: {

        async getMTDReattemptRefresh() {
            try {
                await this.getMTDReattempt();
                } catch (error) {
                 let msg = error + " - getMTDReattemptRefresh";
                this.$alertify.error(msg);
            }
        },

        async getMTDEscalationRefresh() {
            try {
                await this.getMTDEscalation();
                } catch (error) {
                 let msg = error + " - getMTDEscalationRefresh";
                this.$alertify.error(msg);
            }
        },

        async getCancellationReasonsRefresh() {
            try {
                await this.getCancellationReasons();
                } catch (error) {
                 let msg = error + " - getCancellationReasonsRefresh";
                this.$alertify.error(msg);
            }
        },

        async getTop_5_Locations_ComplaintRefresh() {
            try {
                await this.getTop_5_Locations_Complaint();
                } catch (error) {
                 let msg = error + " - getTop_5_Locations_ComplaintRefresh";
                this.$alertify.error(msg);
            }
        },

        async getTop_5_Locations_EscalationRefresh() {
            try {
                await this.getTop_5_Locations_Escalation();
                } catch (error) {
                 let msg = error + " - getTop_5_Locations_EscalationRefresh";
                this.$alertify.error(msg);
            }
        },

        async getCSAWStatusSummaryRefresh() {
            try {
                await this.getCSAWStatusSummary();
                } catch (error) {
                 let msg = error + " - getCSAWStatusSummaryRefresh";
                this.$alertify.error(msg);
            }
        },

     accessRestrictor(){
      var desider=0;
      var n = window.location.href.search('#/b2b/dashboard');
      var link= window.location.href.substr(n+1);
      var linkToo= window.location.href.substr(n+2);
      for(let i=0;i<this.permissiondata.length;i++){
        if(link == this.permissiondata[i].url){
          desider++;
        }
      }
      if(desider == 0){
        this.$router.push('/b2b/dashboard');
        this.$alertify.error("Access Denied for "+ linkToo +" Module.");
      }
    },

        async getSummaryType() {
            var permissiondataEncrypt = window.localStorage.getItem('permissiondata');
            var bytes = CryptoJS.AES.decrypt(permissiondataEncrypt.toString(), 'Key');
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);
            var permissiondata = JSON.parse(plaintext);
            let DashboardArr = permissiondata.filter(function (val) {
                return val.name == "B2B Dashboard";
            });
            for (var i = 0; i < permissiondata.length; i++) {
                if (permissiondata[i].url === '/b2b/trackshipment') {
                    this.b2btrackShipmentAccess = true;
                }
            }
            let childrenArr = DashboardArr[0].children;
            this.SummaryOptionObj = [];
            var forwardObj = '';

            for (var i = 0; i < childrenArr.length; i++) {
                if (childrenArr[i].url === '/b2b/forwardticketsummary') {
                    forwardObj = "1";
                    this.SummarySelectOptionObj = {
                        value: '1',
                        text: 'Forward'
                    };
                    this.SummaryOptionObj.push(this.SummarySelectOptionObj);
                }
            }
            if (forwardObj === "1") {
                this.SummarySelectOptionObj = {
                    value: '1',
                    text: 'Forward'
                };
            }
        },


        async getUserHubList() {
            this.HubOptionObj = [];
            var userhubList = JSON.parse(window.localStorage.getItem(
                "userhubList"
            ));

            for (let i = 0; i < userhubList.length; i++) {
                this.HubSelectOptionObj = {};
                this.HubSelectOptionObj = {
                    value: userhubList[i].value,
                    text: userhubList[i].text
                };
                this.HubOptionObj.push(this.HubSelectOptionObj);
            }
        },

        async getSummaryTypeOLD() {
            var permissiondataEncrypt = window.localStorage.getItem('permissiondata');
            var bytes = CryptoJS.AES.decrypt(permissiondataEncrypt.toString(), 'Key');
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);
            var permissiondata = JSON.parse(plaintext);
            // console.log(permissiondata);
            let DashboardArr = permissiondata.filter(function (val) {
                return val.name == "B2B Dashboard";
            });
            let childrenArr = DashboardArr[0].children;
            this.SummaryOptionObj = [];
            for (var i = 0; i < childrenArr.length; i++) {

                if (childrenArr[i].url === '/forwardticketsummary') {

                    this.SummarySelectOptionObj = {
                        value: '1',
                        text: 'Forward'
                    };
                    this.SummaryOptionObj.push(this.SummarySelectOptionObj);
                }
                if (childrenArr[i].url === '/forwardticketsummary') {
                    this.SummarySelectOptionObj = {
                        value: '1',
                        text: 'Forward'
                    };
                }
                this.SummarySelectOptionObj = {
                    value: '1',
                    text: 'Forward'
                };
            }
        },

        clearValues() {
            this.TicketsSummery.Inquiry = {
                InquiryObj: {
                    Name: '',
                    Values: '',
                    subResone: ''
                },
                InquiryData: [],
                TotalCound: '0',
                OtherCound: '0'
            };
            this.TicketsSummery.Request = {
                RequestObj: {
                    Name: '',
                    Values: '',
                    subResone: ''
                },
                RequestData: [],
                TotalCound: '0',
                OtherCound: '0'
            };
            this.TicketsSummery.Complaint = {
                ComplaintObj: {
                    Name: '',
                    Values: '',
                    subResone: ''
                },
                ComplaintData: [],
                TotalCound: '0',
                OtherCound: '0'
            };
            this.TicketsSummery.Escalation = {
                EscalationObj: {
                    Name: '',
                    Values: '',
                    subResone: ''
                },
                EscalationData: [],
                TotalCount: '0',
                OtherCount: '0'
            };
            this.CancellationReasons.series = [];
            this.TicketsSummery.TwitterTickets.TwitterTicket = [];
            this.TicketsSummery.TopLocations.Toplocation = [];
            this.MTDreatempt.series[0].data = [];
            this.TicketsSummery.TopLocations.ToplocationEscalation = [];
        },

        async refreshTickeSummary() {
            try {
                this.clearValues();
                await this.getTicketsSummery_Enquiry_Request_Complaint1();
                await this.getCancellationReasons();
                await this.getMTDReattempt();
                await this.getMTDEscalation();
                await this.getCSAWStatusSummary();
                await this.getMTDFakeResoneTicket();
                await this.getFakeResoneTicket();
                if (this.InboundMainDiv) {
                    this.getTwitterTickets();
                }
                await this.getTop_5_Locations_Complaint();
                await this.getTop_5_Locations_Escalation();
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - refreshTickeSummary";
                this.$alertify.error(msg);
            }
        },

        async SummaryOption(dataObj) {
            try {
                this.SummarySelectOptionObj = dataObj;
                this.clearValues();
                await this.getTicketsSummery_Enquiry_Request_Complaint1();

                await this.getCancellationReasons();
                await this.getMTDReattempt();
                await this.getMTDEscalation();
                await this.getCSAWStatusSummary();
                await this.getMTDFakeResoneTicket();
                await this.getFakeResoneTicket();
                if (this.InboundMainDiv) {
                    this.getTwitterTickets();
                }
                await this.getTop_5_Locations_Complaint();
                await this.getTop_5_Locations_Escalation();
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - SummaryOption";
                this.$alertify.error(msg);
            }
        },

        AutoIVROption(dataObj) {
            try {
                this.AutoIVRSelectOptionObj = dataObj;
                let DialerType = dataObj.value;
                this.getAutoIVRCallSummary(DialerType);
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - AutoIVROption";
                this.$alertify.error(msg);
            }
        },

        async getIvrInboundSummeryDetails_bk() {
            let token = 'Tu1ZyG';
            let today = new Date();
            let dd = today.getDate();
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            let date = yyyy + '-' + mm + '-' + dd;

            await axios({
                    method: 'POST',
                    url: apiUrl.api_url + 'getIvrInboundSummeryDetails',
                    data: {
                        fromDate: date,
                        toDate: date
                    },
                    datatype: 'json',
                    headers: commonFunction.getusertoken(),
                })
                .then(result => {
                    this.isLoadingTopInboundContact = false;
                    let resultDataCrm = result.data.data;
                    if (resultDataCrm.status) {
                        let resultData = result.data.data.data.data;

                        let resultDataOBJ = resultData[0];
                        //console.log(resultDataOBJ);
                        let holdtime = this.secondsToMinutes(resultDataOBJ.holdTime);
                        let aht = this.secondsToMinutes(resultDataOBJ.AHT);
                        this.InboundContactCenter.AHT = (aht == null) ? '0' : aht;
                        this.InboundContactCenter.MissedCall = (resultDataOBJ.MissedCall == null) ? '0' : resultDataOBJ.MissedCall;
                        this.InboundContactCenter.RepeatCalls = (resultDataOBJ.RepeatCalls == null) ? '0' : resultDataOBJ.RepeatCalls;
                        this.InboundContactCenter.holdTime = (holdtime == null) ? '0' : holdtime;
                    } else {
                        this.isLoadingTopInboundContact = false;
                        let msg = resultDataCrm.msg;
                        this.$alertify.error(msg);
                    }
                }, error => {
                    this.isLoadingTopInboundContact = false;
                    let msg = error;
                    this.$alertify.error(msg);
                });
        },

        async getIvrInboundSummeryDetails() {
            try {
                let token = 'Tu1ZyG';
                let today = new Date();
                let dd = today.getDate();
                let mm = today.getMonth() + 1;
                let yyyy = today.getFullYear();
                let date = yyyy + '-' + mm + '-' + dd;

                await axios({
                        method: 'POST',
                        url: apiUrl.crmivr_url + 'crmivr_live/IvrCallSummeryApi/getInboundCallingFlashData',
                        data: "fromDate=" + date + "&toDate=" + date,
                        datatype: 'json',
                        headers: commonFunction.getusertoken(),
                    })
                    .then(result => {
                        this.isLoadingTopInboundContact = false;
                        this.isLoadingInboundCallsFibucation = false;
                        let resultDataCrm = result.data;
                        if (resultDataCrm.status == 'success') {
                            let resultData = result.data.data;
                            let resultDataOBJ = resultData[0];

                            // inbound summery start
                            //console.log(resultDataOBJ);
                            var hoTime = ((resultDataOBJ.holdTime == null) ? 0 : resultDataOBJ.holdTime);
                            var ho_ti = 0;
                            if (resultDataOBJ.AnsweredByCC > 0) {
                                ho_ti = (hoTime / resultDataOBJ.AnsweredByCC);
                            }
                            let holdtime = this.secondsToMinutes(ho_ti);
                            let aht = this.secondsToMinutes(resultDataOBJ.AHT);
                            this.InboundContactCenter.AHT = (aht == null) ? '0' : aht;
                            this.InboundContactCenter.MissedCall = (resultDataOBJ.MissedCall == null) ? '0' : resultDataOBJ.MissedCall;
                            this.InboundContactCenter.RepeatCalls = (resultDataOBJ.RepeatCalls == null) ? '0' : resultDataOBJ.RepeatCalls;
                            this.InboundContactCenter.holdTime = (holdtime == null) ? '0' : holdtime;
                            // inbound summery end
                            // pie chart start
                            let chartData = Array();
                            let chartData1 = Array();

                            chartData[0] = resultDataOBJ.CallTransferToCC;
                            chartData[1] = resultDataOBJ.TakenCareByIVR;
                            chartData[2] = resultDataOBJ.QueueFull;
                            chartData[3] = resultDataOBJ.ChannelUnavailable;
                            chartData[4] = resultDataOBJ.HolidaySetting;

                            chartData1[0] = resultDataOBJ.MissedCall;
                            chartData1[1] = resultDataOBJ.AnsweredByCC;


                            let objdata = {
                                name: 'Inbound Calls',
                                colorByPoint: true,
                                center: ['35%'],
                                data: [],
                                size: 190
                            };

                            let objdata1 = {
                                name: 'Call Transfer To CC',
                                colorByPoint: true,
                                center: ['87%'],
                                data: [],
                                size: 100
                            };

                            let MissedCall = {
                                name: 'Missed Call',
                                y: parseInt(resultDataOBJ.MissedCall),
                                color: 'red'
                            };

                            let AnsweredByCC = {
                                name: 'Answered By CC',
                                y: parseInt(resultDataOBJ.AnsweredByCC),
                                color: '#7da144'
                            };

                            let CallTransferToCC = {
                                name: 'Call Transfer To CC',
                                y: parseInt(resultDataOBJ.CallTransferToCC)
                            };

                            let TakenCareByIVR = {
                                name: 'TakenCare By IVR',
                                y: parseInt(resultDataOBJ.TakenCareByIVR)
                            };

                            let QueueFull = {
                                name: 'Queue Full',
                                y: parseInt(resultDataOBJ.QueueFull)
                            };

                            let ChannelUnavailable = {
                                name: 'Channel Unavailable',
                                y: parseInt(resultDataOBJ.ChannelUnavailable)
                            };

                            let HolidaySetting = {
                                name: 'Holiday Setting',
                                y: parseInt(resultDataOBJ.HolidaySetting)
                            };

                            objdata.data.push(CallTransferToCC);
                            objdata.data.push(TakenCareByIVR);
                            objdata.data.push(QueueFull);
                            objdata.data.push(ChannelUnavailable);
                            objdata.data.push(HolidaySetting);

                            objdata1.data.push(MissedCall);
                            objdata1.data.push(AnsweredByCC);

                            this.InboundcallsPie.series.push(objdata);
                            this.InboundcallsPie.series.push(objdata1);

                            // pie chart end
                        } else {
                            this.isLoadingTopInboundContact = false;
                            this.isLoadingInboundCallsFibucation = false;
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        this.isLoading = false;
                        this.isLoadingTopInboundContact = false;
                        this.isLoadingInboundCallsFibucation = false;
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getIvrInboundSummeryDetails";
                this.$alertify.error(msg);
            }
        },

        async getIvrInboundMTDSummeryDetails() {
            try {
                let token = 'Tu1ZyG';
                let today = new Date();
                let dd = today.getDate();
                let mm = today.getMonth() + 1;
                let yyyy = today.getFullYear();
                let date = yyyy + '-' + mm + '-' + dd;
                let firstday = yyyy + '-' + mm + '-' + "01";

                await axios({
                        method: 'POST',
                        url: apiUrl.crmivr_url + 'crmivr_live/IvrCallSummeryApi/getInboundCallingFlashData',
                        data: "fromDate=" + firstday + "&toDate=" + date,
                        datatype: 'json',
                        headers: commonFunction.getusertoken(),
                    })
                    .then(result => {
                        this.isLoadingTopInboundContactMTD = false;
                        let resultDataCrm = result.data;
                        if (resultDataCrm.status == 'success') {
                            let resultData = result.data.data;
                            let resultDataMTD = resultData[0];

                            let serviceLevel = 0;
                            if (resultDataMTD.CallTransferToCC > 0) {
                                serviceLevel = ((resultDataMTD.AnsweredByCC / resultDataMTD.CallTransferToCC) * 100);
                            }

                            this.InboundContactCenter.MissedCallMTD = resultDataMTD.MissedCall;
                            this.InboundContactCenter.RepeatCallsMTD = resultDataMTD.RepeatCalls;
                            this.InboundContactCenter.serviceLevel = (Math.round(serviceLevel * 100) / 100);

                        } else {
                            this.isLoadingTopInboundContactMTD = false;
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        this.isLoadingTopInboundContactMTD = false;
                        let msg = error;
                        this.$alertify.error(msg);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getIvrInboundMTDSummeryDetails";
                this.$alertify.error(msg);
            }
        },

        async getIvrInboundMTDSummeryDetails_bk() {
            let token = 'Tu1ZyG';
            let today = new Date();
            let dd = today.getDate();
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            let date = yyyy + '-' + mm + '-' + dd;
            let firstday = yyyy + '-' + mm + '-' + "01";

            await axios({
                    method: 'POST',
                    url: apiUrl.api_url + 'getIvrInboundSummeryDetails',
                    data: {
                        fromDate: firstday,
                        toDate: date
                    },
                    datatype: 'json',
                    headers: commonFunction.getusertoken(),
                })
                .then(result => {
                    this.isLoadingTopInboundContactMTD = false;
                    let resultDataCrm = result.data.data;
                    if (resultDataCrm.status) {
                        let resultData = result.data.data.data.data;
                        let resultDataMTD = resultData[0];

                        let serviceLevel = 0;
                        if (resultDataMTD.CallTransferToCC > 0) {
                            serviceLevel = ((resultDataMTD.AnsweredByCC / resultDataMTD.CallTransferToCC) * 100);
                        }

                        this.InboundContactCenter.MissedCallMTD = resultDataMTD.MissedCall;
                        this.InboundContactCenter.RepeatCallsMTD = resultDataMTD.RepeatCalls;
                        this.InboundContactCenter.serviceLevel = (Math.round(serviceLevel * 100) / 100);

                    } else {
                        this.isLoadingTopInboundContactMTD = false;
                        let msg = resultDataCrm.msg;
                        this.$alertify.error(msg);
                    }
                }, error => {
                    this.isLoadingTopInboundContactMTD = false;
                    let msg = error;
                    this.$alertify.error(msg);
                });
        },

        async getOutBoundCallingFlashData() {
            try {
                let token = 'Tu1ZyG';
                let today = new Date();
                let dd = today.getDate();
                let mm = today.getMonth() + 1;
                let yyyy = today.getFullYear();
                let date = yyyy + '-' + mm + '-' + dd;
                await axios({
                        method: 'POST',
                        url: apiUrl.crmivr_url + 'crmivr_live/IvrCallSummeryApi/getOutBoundCallingFlashData',
                        data: "fromDate=" + date + "&toDate=" + date,
                        datatype: 'json',
                        headers: commonFunction.getusertoken(),
                    })
                    .then(result => {
                        this.isLoadingOutboundContactTodayPerformance = false;
                        let resultDataCrm = result.data;
                        if (resultDataCrm.status) {
                            let resultData = result.data.data;

                            let resultDataOBJ = resultData[0];
                            let holdtime = 0;

                            if (resultDataOBJ.HoldTime) {
                                let holdtimeOBJ = resultDataOBJ.HoldTime.split(":");
                                holdtime = holdtimeOBJ[1] + ':' + holdtimeOBJ[2];
                            }

                            let aht = this.secondsToMinutes(resultDataOBJ.AHT);

                            let Missed = (resultDataOBJ.Missed == null) ? '0' : resultDataOBJ.Missed;
                            let Success = (resultDataOBJ.Success == null) ? '0' : resultDataOBJ.Success;

                            this.OutBoundContactCenter.Missed = Missed;
                            this.OutBoundContactCenter.AHT = (aht == null) ? '0' : aht;
                            this.OutBoundContactCenter.HoldTime = (holdtime == null) ? '0' : holdtime;

                        } else {
                            this.isLoadingOutboundContactTodayPerformance = false;
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        this.isLoadingOutboundContactTodayPerformance = false;
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getOutBoundCallingFlashData";
                this.$alertify.error(msg);
            }
        },

        async getOutBoundMTDCallingFlashData() {
            try {
                this.isLoadingOutboundContactMTDPerformance = true;
                let token = 'Tu1ZyG';

                let today = new Date();
                let dd = today.getDate();
                let mm = today.getMonth() + 1;
                let yyyy = today.getFullYear();
                let date = yyyy + '-' + mm + '-' + dd;
                let firstday = yyyy + '-' + mm + '-' + "01";

                await axios({
                        method: 'POST',
                        url: apiUrl.crmivr_url + 'crmivr_live/IvrCallSummeryApi/getOutBoundCallingFlashData',
                        data: "fromDate=" + firstday + "&toDate=" + date,
                        datatype: 'json',
                        headers: commonFunction.getusertoken(),
                    })
                    .then(result => {
                        this.isLoadingOutboundContactMTDPerformance = false;
                        let resultDataCrm = result.data;
                        if (resultDataCrm.status == 'success') {
                            let resultData = result.data.data;

                            let resultDataOBJ = resultData[0];

                            let holdtime = 0;
                            if (resultDataOBJ.HoldTime) {
                                let holdtimeOBJ = resultDataOBJ.HoldTime.split(":");
                                holdtime = holdtimeOBJ[1] + ':' + holdtimeOBJ[2];
                            }

                            let aht = this.secondsToMinutes(resultDataOBJ.AHT);

                            let Missed = (resultDataOBJ.Missed == null) ? '0' : resultDataOBJ.Missed;
                            let Success = (resultDataOBJ.Success == null) ? '0' : resultDataOBJ.Success;

                            this.OutBoundMTDContactCenter.Missed = Missed;
                            this.OutBoundMTDContactCenter.AHT = (aht == null) ? '0' : aht;
                            this.OutBoundMTDContactCenter.HoldTime = (holdtime == null) ? '0' : holdtime;


                        } else {
                            this.isLoadingOutboundContactMTDPerformance = false;
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        this.isLoadingOutboundContactMTDPerformance = false;
                        let msg = error;
                        this.$alertify.error(msg);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getOutBoundMTDCallingFlashData";
                this.$alertify.error(msg);
            }
        },

        async getOutBoundMTDCallingFlashData_bk() {
            this.isLoadingOutboundContactMTDPerformance = true;
            let token = 'Tu1ZyG';

            let today = new Date();
            let dd = today.getDate() + 1;
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            let date = yyyy + '-' + mm + '-' + dd;
            let firstday = yyyy + '-' + mm + '-' + "01";

            await axios({
                    method: 'POST',
                    url: apiUrl.api_url + 'getOutBoundCallingFlashData',
                    data: {
                        fromDate: firstday,
                        toDate: date
                    },
                    datatype: 'json',
                    headers: commonFunction.getusertoken(),
                })
                .then(result => {
                    this.isLoadingOutboundContactMTDPerformance = false;
                    let resultDataCrm = result.data.data;
                    if (resultDataCrm.status) {
                        let resultData = result.data.data.data.data;

                        let resultDataOBJ = resultData[0];

                        let holdtimeOBJ = resultDataOBJ.HoldTime.split(":");
                        let holdtime = holdtimeOBJ[1] + ':' + holdtimeOBJ[2];

                        let aht = this.secondsToMinutes(resultDataOBJ.AHT);

                        let Missed = (resultDataOBJ.Missed == null) ? '0' : resultDataOBJ.Missed;
                        let Success = (resultDataOBJ.Success == null) ? '0' : resultDataOBJ.Success;

                        this.OutBoundMTDContactCenter.Missed = Missed;
                        this.OutBoundMTDContactCenter.AHT = (aht == null) ? '0' : aht;
                        this.OutBoundMTDContactCenter.HoldTime = (holdtime == null) ? '0' : holdtime;

                    } else {
                        this.isLoadingOutboundContactMTDPerformance = false;
                        let msg = resultDataCrm.msg;
                        this.$alertify.error(msg);
                    }
                }, error => {
                    this.isLoadingOutboundContactMTDPerformance = false;
                    let msg = error;
                    this.$alertify.error(msg);
                });
        },

        secondsToMinutes(time) {
            let minute = Math.floor(time / 60);
            let second = Math.floor(time % 60);
            return ((minute == null) ? '00' : minute) + ':' + ((second == null) ? '00' : second);
        },

        async getNDRCallSummary() {
            try {
                this.isLoadingNDRCallSummary = true;

                let token = 'Tu1ZyG';
                await axios({
                        method: 'GET',
                        url: apiUrl.crmivr_url + 'crmivr_live/IvrCallSummeryApi/GetNDRCallSummary',
                        datatype: 'json',
                        headers: commonFunction.getusertoken(),
                    })
                    .then(result => {
                        this.isLoadingNDRCallSummary = false;
                        this.isLoadingNDRCallLineChart = false;
                        let resultDataCrm = result.data;

                        if (resultDataCrm.status == 'success') {
                            let resultData = result.data.data;

                            this.NDRCallSummary.NDRCallSummaryData = [];
                            let DownloadedTotal = 0;
                            let SuccessTotal = 0;
                            let FailedTotal = 0;
                            let MissedTotal = 0;
                            let DialedTotal = 0;
                            let NotDialedTotal = 0;
                            let NDRCnt = resultData[0].length;
                            this.NDRCallSummary.NDRCnt = NDRCnt;

                            for (let i = 0; i < NDRCnt; i++) {
                                let TotalDownload = "";
                                let Success = 0;
                                let Failed = 0;
                                let Missed = 0;
                                let Dailed = 0;
                                let NotDailed = 0;

                                if (resultData[0][i].TotalDownload != null) {
                                    TotalDownload = resultData[0][i].TotalDownload;
                                    DownloadedTotal += parseInt(TotalDownload);
                                }

                                if (resultData[0][i].Success != null) {
                                    Success = resultData[0][i].Success;
                                    SuccessTotal += parseInt(Success);
                                }
                                if (resultData[0][i].Failed != null) {
                                    Failed = resultData[0][i].Failed;
                                    FailedTotal += parseInt(Failed);
                                }
                                if (resultData[0][i].Missed != null) {
                                    Missed = resultData[0][i].Missed;
                                    MissedTotal += parseInt(Missed);
                                }
                                if (resultData[0][i].Dialed != null) {
                                    Dailed = resultData[0][i].Dialed;
                                    DialedTotal += parseInt(Dailed);
                                }
                                if (resultData[0][i].NotDialed != null) {
                                    NotDailed = resultData[0][i].NotDialed;
                                    NotDialedTotal += parseInt(NotDailed);
                                }

                                this.NDRCallSummary.DownloadedTotal = DownloadedTotal;
                                this.NDRCallSummary.SuccessTotal = SuccessTotal;
                                this.NDRCallSummary.FailedTotal = FailedTotal;
                                this.NDRCallSummary.MissedTotal = MissedTotal;
                                this.NDRCallSummary.DialedTotal = DialedTotal;
                                this.NDRCallSummary.NotDialedTotal = NotDialedTotal;

                                this.NDRCallSummary.NDRCallSummaryElement = {};

                                this.NDRCallSummary.NDRCallSummaryElement.CallDate = (resultData[0][i].CallDate == null) ? '0' : resultData[0][i].CallDate;
                                this.NDRCallSummary.NDRCallSummaryElement.Dialed = Dailed;
                                this.NDRCallSummary.NDRCallSummaryElement.DownloadDate = (resultData[0][i].DownloadDate == null) ? '0' : resultData[0][i].DownloadDate;
                                this.NDRCallSummary.NDRCallSummaryElement.Ext = (resultData[0][i].Ext == null) ? '0' : resultData[0][i].Ext;
                                this.NDRCallSummary.NDRCallSummaryElement.Exten = (resultData[0][i].Exten == null) ? '0' : resultData[0][i].Exten;
                                this.NDRCallSummary.NDRCallSummaryElement.Failed = Failed;
                                this.NDRCallSummary.NDRCallSummaryElement.Languages = (resultData[0][i].Languages == null) ? '0' : resultData[0][i].Languages;
                                this.NDRCallSummary.NDRCallSummaryElement.Missed = Missed;
                                this.NDRCallSummary.NDRCallSummaryElement.NotDialed = NotDailed;
                                this.NDRCallSummary.NDRCallSummaryElement.Success = Success;
                                this.NDRCallSummary.NDRCallSummaryElement.TotalDownload = TotalDownload;

                                this.NDRCallSummary.NDRCallSummaryData.push(this.NDRCallSummary.NDRCallSummaryElement);
                            }


                            // start ndr summary line chart

                            let hours = Array();
                            let AHT = Array();
                            let Success1 = Array();
                            let Failed1 = Array();
                            let totalCalls = Array();
                            let HoldTime = Array();
                            let Missed1 = Array();


                            let AHTOBJ = {
                                name: '',
                                data: []
                            };
                            let SuccessOBJ = {
                                name: '',
                                data: [],
                                color: '#96BA5D',
                            };
                            let FailedOBJ = {
                                name: '',
                                data: [],
                                color: '#000000'
                            };
                            let totalCallsOBJ = {
                                name: '',
                                data: [],
                                color: '#7CB5EC'
                            };
                            let HoldTimeOBJ = {
                                name: '',
                                data: []
                            };
                            let MissedOBJ = {
                                name: '',
                                data: [],
                                color: '#FF0000'
                            };

                            for (let i = 0; i < resultData[1].length; i++) {
                                AHT[i] = parseInt(resultData[1][i].AHT);
                                Success1[i] = parseInt(resultData[1][i].Success);
                                Failed1[i] = parseInt(resultData[1][i].Failed);
                                totalCalls[i] = parseInt(resultData[1][i].totalCalls);
                                hours[i] = parseInt(resultData[1][i].hours);
                                HoldTime[i] = parseInt(resultData[1][i].HoldTime);
                                Missed1[i] = parseInt(resultData[1][i].Missed);
                            }

                            this.NDRcallsLine.xAxis.categories = hours;

                            AHTOBJ.name = 'AHT';
                            AHTOBJ.data = AHT;

                            SuccessOBJ.name = 'Success';
                            SuccessOBJ.data = Success1;

                            FailedOBJ.name = 'Failed';
                            FailedOBJ.data = Failed1;

                            totalCallsOBJ.name = 'totalCalls';
                            totalCallsOBJ.data = totalCalls;

                            HoldTimeOBJ.name = 'HoldTime';
                            HoldTimeOBJ.data = HoldTime;
                            MissedOBJ.name = 'Missed';
                            MissedOBJ.data = Missed1;

                            //this.NDRcallsLine.series.push(AHTOBJ);
                            this.NDRcallsLine.series.push(SuccessOBJ);
                            this.NDRcallsLine.series.push(FailedOBJ);
                            this.NDRcallsLine.series.push(totalCallsOBJ);
                            this.NDRcallsLine.series.push(HoldTimeOBJ);
                            this.NDRcallsLine.series.push(MissedOBJ);

                            // end  ndr summary line chart
                        }
                    }, error => {
                        this.isLoadingNDRCallSummary = false;
                        this.isLoadingNDRCallLineChart = false;
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getNDRCallSummary";
                this.$alertify.error(msg);
            }
        },

        async getNDRCallSummary_bk() {

            this.isLoadingNDRCallSummary = true;

            let token = 'Tu1ZyG';
            await axios({
                    method: 'GET',
                    url: apiUrl.api_url + 'getNDRCallSummary',
                    datatype: 'json',
                    headers: commonFunction.getusertoken(),
                })
                .then(result => {
                    this.isLoadingNDRCallSummary = false;
                    let resultDataCrm = result.data.data;
                    if (resultDataCrm.status) {
                        let resultData = result.data.data.data.data;
                        //console.log(resultData);
                        this.NDRCallSummary.NDRCallSummaryData = [];
                        let DownloadedTotal = 0;
                        let SuccessTotal = 0;
                        let FailedTotal = 0;
                        let MissedTotal = 0;
                        let DialedTotal = 0;
                        let NotDialedTotal = 0;
                        let NDRCnt = resultData.length;
                        this.NDRCallSummary.NDRCnt = NDRCnt;
                        for (let i = 0; i < NDRCnt; i++) {
                            let TotalDownload = "";
                            let Success = 0;
                            let Failed = 0;
                            let Missed = 0;
                            let Dailed = 0;
                            let NotDailed = 0;

                            if (resultData[i].TotalDownload != null) {
                                TotalDownload = resultData[i].TotalDownload;
                                DownloadedTotal += parseInt(TotalDownload);
                            }

                            if (resultData[i].Success != null) {
                                Success = resultData[i].Success;
                                SuccessTotal += parseInt(Success);
                            }
                            if (resultData[i].Failed != null) {
                                Failed = resultData[i].Failed;
                                FailedTotal += parseInt(Failed);
                            }
                            if (resultData[i].Missed != null) {
                                Missed = resultData[i].Missed;
                                MissedTotal += parseInt(Missed);
                            }
                            if (resultData[i].Dialed != null) {
                                Dailed = resultData[i].Dialed;
                                DialedTotal += parseInt(Dailed);
                            }
                            if (resultData[i].NotDialed != null) {
                                NotDailed = resultData[i].NotDialed;
                                NotDialedTotal += parseInt(NotDailed);
                            }

                            this.NDRCallSummary.DownloadedTotal = DownloadedTotal;
                            this.NDRCallSummary.SuccessTotal = SuccessTotal;
                            this.NDRCallSummary.FailedTotal = FailedTotal;
                            this.NDRCallSummary.MissedTotal = MissedTotal;
                            this.NDRCallSummary.DialedTotal = DialedTotal;
                            this.NDRCallSummary.NotDialedTotal = NotDialedTotal;

                            this.NDRCallSummary.NDRCallSummaryElement = {};

                            this.NDRCallSummary.NDRCallSummaryElement.CallDate = (resultData[i].CallDate == null) ? '0' : resultData[i].CallDate;
                            this.NDRCallSummary.NDRCallSummaryElement.Dialed = Dailed;
                            this.NDRCallSummary.NDRCallSummaryElement.DownloadDate = (resultData[i].DownloadDate == null) ? '0' : resultData[i].DownloadDate;
                            this.NDRCallSummary.NDRCallSummaryElement.Ext = (resultData[i].Ext == null) ? '0' : resultData[i].Ext;
                            this.NDRCallSummary.NDRCallSummaryElement.Exten = (resultData[i].Exten == null) ? '0' : resultData[i].Exten;
                            this.NDRCallSummary.NDRCallSummaryElement.Failed = Failed;
                            this.NDRCallSummary.NDRCallSummaryElement.Languages = (resultData[i].Languages == null) ? '0' : resultData[i].Languages;
                            this.NDRCallSummary.NDRCallSummaryElement.Missed = Missed;
                            this.NDRCallSummary.NDRCallSummaryElement.NotDialed = NotDailed;
                            this.NDRCallSummary.NDRCallSummaryElement.Success = Success;
                            this.NDRCallSummary.NDRCallSummaryElement.TotalDownload = TotalDownload;

                            this.NDRCallSummary.NDRCallSummaryData.push(this.NDRCallSummary.NDRCallSummaryElement);
                        }
                    } else {
                        this.isLoadingNDRCallSummary = false;
                        let msg = resultDataCrm.msg;
                        this.$alertify.error(msg);
                    }
                }, error => {
                    this.isLoadingNDRCallSummary = false;
                    let msg = error;
                    this.$alertify.error(msg);
                });
        },

        async getInboundCallEsc() {
            try {
                let token = 'Tu1ZyG';
                await axios({
                        method: 'GET',
                        url: apiUrl.crmivr_url + 'crmivr_live/IvrCallSummeryApi/getInboundCallEsc',
                        datatype: 'json',
                        headers: commonFunction.getusertoken(),
                    })
                    .then(result => {
                        let resultDataCrm = result.data;
                        if (resultDataCrm.status == 'success') {
                            let resultData = result.data.data;
                            let Esctime = resultData[0].Esc;

                            if (Esctime) {
                                let escdt = Esctime.split(':');
                                let escf = escdt[1] + ':' + escdt[2];
                                this.InboundContactCenter.Esc = escf;
                            }
                        } else {
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getInboundCallEsc";
                this.$alertify.error(msg);
            }
        },

        async getAutoIVRCallSummary(DialerType) {
            try {
                this.isLoadingAutoIVRCallTable = true;
                let token = 'Tu1ZyG';
                this.AutoIVRCallSummary.AutoIVRCallSummaryData = [];
                await axios({
                        method: 'POST',
                        url: apiUrl.crmivr_url + 'crmivr_live/IvrCallSummeryApi/getAutoIVRCallSummary_new1',
                        datatype: 'json',
                        data: "DialerType=" + DialerType,
                        headers: commonFunction.getusertoken(),
                    })
                    .then(result => {
                        this.isLoadingAutoIVRCallTable = false;
                        this.isLoadingAutoIVRCallLine = false;
                        this.AutoIVRCallSummary.AutoIVRCallSummaryData = [];
                        this.AutoIVRCallsLine.series = [];

                        let CategoryNames = Array();
                        let SuccessOBJ = {
                            name: '',
                            data: [],
                            color: '#96BA5D'
                        };
                        let Success = Array();
                        let FaildOBJ = {
                            name: '',
                            data: [],
                            color: '#000000'
                        };
                        let Faild = Array();

                        let resultData = result.data.data;
                        if (resultData.length > 0) {
                            let AutoIVRCnt = resultData[0].length;
                            this.AutoIVRCallSummary.DialerType = DialerType;
                            this.AutoIVRCallSummary.AutoIVRCnt = AutoIVRCnt;
                            var CongestionCnt = 0;
                            var FaildCnt = 0;
                            var IsbusyCnt = 0;
                            var IsringingCnt = 0;
                            var SuccessCnt = 0;
                            var TotalCallsCnt = 0;
                            var WrongNumberCnt = 0;
                            var DeliveredCnt = 0;
                            var NotDeliveredCnt = 0;
                            var NoResponceCnt = 0;
                            this.showTable = 1;
                            for (let i = 0; i < AutoIVRCnt; i++) {
                                CategoryNames[i] = (resultData[0][i].HubZone == null) ? '-' : resultData[0][i].HubZone;
                                Success[i] = parseInt((resultData[0][i].Success == null) ? '0' : resultData[0][i].Success);
                                Faild[i] = parseInt((resultData[0][i].Faild == null) ? '0' : resultData[0][i].Faild);


                                this.AutoIVRCallSummary.AutoIVRCallSummaryElement = {};
                                CongestionCnt = (CongestionCnt + parseInt((resultData[0][i].Congestion == null) ? '0' : resultData[0][i].Congestion));
                                FaildCnt = (FaildCnt + parseInt((resultData[0][i].Faild == null) ? '0' : resultData[0][i].Faild));
                                IsbusyCnt = (IsbusyCnt + parseInt((resultData[0][i].Isbusy == null) ? '0' : resultData[0][i].Isbusy));
                                IsringingCnt = (IsringingCnt + parseInt((resultData[0][i].Isringing == null) ? '0' : resultData[0][i].Isringing));
                                SuccessCnt = (SuccessCnt + parseInt((resultData[0][i].Success == null) ? '0' : resultData[0][i].Success));


                                TotalCallsCnt = (TotalCallsCnt + parseInt((resultData[0][i].TotalCalls == null) ? '0' : resultData[0][i].TotalCalls));
                                WrongNumberCnt = (WrongNumberCnt + parseInt((resultData[0][i].WrongNumber == null) ? '0' : resultData[0][i].WrongNumber));
                                this.AutoIVRCallSummary.AutoIVRCallSummaryElement.Congestion = (resultData[0][i].Congestion == null) ? '0' : resultData[0][i].Congestion;
                                this.AutoIVRCallSummary.AutoIVRCallSummaryElement.Faild = (resultData[0][i].Faild == null) ? '0' : resultData[0][i].Faild;
                                this.AutoIVRCallSummary.AutoIVRCallSummaryElement.HubZone = (resultData[0][i].HubZone == null) ? '-' : resultData[0][i].HubZone;
                                this.AutoIVRCallSummary.AutoIVRCallSummaryElement.Isbusy = (resultData[0][i].Isbusy == null) ? '0' : resultData[0][i].Isbusy;
                                this.AutoIVRCallSummary.AutoIVRCallSummaryElement.Isringing = (resultData[0][i].Isringing == null) ? '0' : resultData[0][i].Isringing;
                                this.AutoIVRCallSummary.AutoIVRCallSummaryElement.Success = (resultData[0][i].Success == null) ? '0' : resultData[0][i].Success;
                                this.AutoIVRCallSummary.AutoIVRCallSummaryElement.TotalCalls = (resultData[0][i].TotalCalls == null) ? '0' : resultData[0][i].TotalCalls;
                                this.AutoIVRCallSummary.AutoIVRCallSummaryElement.WrongNumber = (resultData[0][i].WrongNumber == null) ? '0' : resultData[0][i].WrongNumber;

                                if (DialerType == "3") {
                                    DeliveredCnt = (DeliveredCnt + parseInt((resultData[0][i].Delivered == null) ? '0' : resultData[0][i].Delivered));
                                    NotDeliveredCnt = (NotDeliveredCnt + parseInt((resultData[0][i].NotDelivered == null) ? '0' : resultData[0][i].NotDelivered));
                                    NoResponceCnt = (NoResponceCnt + parseInt((resultData[0][i].NoResponce == null) ? '0' : resultData[0][i].NoResponce));
                                    this.AutoIVRCallSummary.AutoIVRCallSummaryElement.Delivered = (resultData[0][i].Delivered == null) ? '0' : resultData[0][i].Delivered;
                                    this.AutoIVRCallSummary.AutoIVRCallSummaryElement.NotDelivered = (resultData[0][i].NotDelivered == null) ? '0' : resultData[0][i].NotDelivered;
                                    this.AutoIVRCallSummary.AutoIVRCallSummaryElement.NoResponce = (resultData[0][i].NoResponce == null) ? '0' : resultData[0][i].NoResponce;
                                }

                                this.AutoIVRCallSummary.AutoIVRCallSummaryData.push(this.AutoIVRCallSummary.AutoIVRCallSummaryElement);
                            }

                            this.AutoIVRCallSummary.AutoIVRCallSummaryElement = {};

                            this.AutoIVRCallSummary.AutoIVRCallSummaryElement.Congestion = CongestionCnt;
                            this.AutoIVRCallSummary.AutoIVRCallSummaryElement.Faild = FaildCnt;
                            this.AutoIVRCallSummary.AutoIVRCallSummaryElement.HubZone = "Total";
                            this.AutoIVRCallSummary.AutoIVRCallSummaryElement.Isbusy = IsbusyCnt;
                            this.AutoIVRCallSummary.AutoIVRCallSummaryElement.Isringing = IsringingCnt;
                            this.AutoIVRCallSummary.AutoIVRCallSummaryElement.Success = SuccessCnt;
                            this.AutoIVRCallSummary.AutoIVRCallSummaryElement.TotalCalls = TotalCallsCnt;
                            this.AutoIVRCallSummary.AutoIVRCallSummaryElement.WrongNumber = WrongNumberCnt;

                            if (DialerType == "3") {
                                this.AutoIVRCallSummary.AutoIVRCallSummaryElement.Delivered = DeliveredCnt;
                                this.AutoIVRCallSummary.AutoIVRCallSummaryElement.NotDelivered = NotDeliveredCnt;
                                this.AutoIVRCallSummary.AutoIVRCallSummaryElement.NoResponce = NoResponceCnt;
                            }

                            this.AutoIVRCallSummary.AutoIVRCallSummaryData.push(this.AutoIVRCallSummary.AutoIVRCallSummaryElement);

                            this.AutoIVRCallsLine.xAxis.categories = CategoryNames;
                            SuccessOBJ.name = 'Success';
                            SuccessOBJ.data = Success;
                            FaildOBJ.name = 'Failed';
                            FaildOBJ.data = Faild;
                            this.AutoIVRCallsLine.series.push(SuccessOBJ);
                            this.AutoIVRCallsLine.series.push(FaildOBJ);
                        } else {
                            this.showTable = 0;
                            this.isLoadingAutoIVRCallTable = false;
                            this.isLoadingAutoIVRCallLine = false;
                        }
                    }, error => {
                        this.isLoadingAutoIVRCallTable = false;
                        this.isLoadingAutoIVRCallLine = false;
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getAutoIVRCallSummary";
                this.$alertify.error(msg);
            }
        },

        async getTicketsSummery_Enquiry_Request_Complaint1() {
            try {
                // var businessflow = this.SummarySelectOptionObj.text;
                var businessflow = 'Forward'
                this.isLoading = true;
                let userReporting = window.localStorage.getItem('userReporting');
                var userDepartmentId = await this.getUserDepartmet();

                var hubId = "";
                if (userDepartmentId == this.FieldOperationId) {
                    if (this.HubSelectOptionObj.value) {
                        hubId = (this.HubSelectOptionObj.value).toString();
                    }
                }
                var userClientName = "";
                if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport || userDepartmentId == this.B2BClientSupport) {
                    var userClientNameStr = "";
                    userClientNameStr = this.clientlistOptionObj.text;
                    if (userClientNameStr) {
                        var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                        userClientName = "'" + userClientNameObj + "'";
                        if (userClientName == "'MULTIPLE'") {
                            var userClientName1 = window.localStorage.getItem('userclientNames');
                            userClientName = userClientName1;
                        } else if (userClientName == "'ALL'") {
                            userClientName = "";
                        } else if (userClientName == "''") {
                            userClientName = "'-1'";
                        }
                    }
                }
                const secretKey = constantVariable.enckey;
                const encryptedData = AES.encrypt(userReporting, secretKey).toString();
                let ecuserReporting = encryptedData.replace(/[=]/g, '_');
                this.input = ({
                    userid: ecuserReporting,
                    userDepartmentId: userDepartmentId,
                    businessflow: 'Forward',
                    hubId: '',
                    userClientName: ''
                });
                axios({
                        method: 'POST',
                        url: apiUrl.api_url + 'getB2BDashboardTicketCount',
                        datatype: 'json',
                        data: this.input,
                        headers: commonFunction.getusertoken(),
                    })
                    .then(result => {
                        this.isLoading = false;
                        let resultDataCrm = result.data.data.data;
                        let Complaint = resultDataCrm.Complaint;
                        let Inquiry = resultDataCrm.Inquiry;
                        let Request = resultDataCrm.Request;

                        var total_inquiry = 0;
                        var total_complaint = 0;
                        var total_request = 0;

                        var comCount = 0;
                        var comOtherCount = 0;
                        var comOtherSubResone = [];

                        if (Complaint.length > 0) {
                            for (let obj in Complaint) {
                                total_complaint = parseInt(total_complaint) + parseInt(Complaint[obj].totalcount);
                                this.TicketsSummery.Complaint.TotalCound = total_complaint;
                                comCount = comCount + 1;
                                this.TicketsSummery.Complaint.ComplaintObj = {};
                                this.TicketsSummery.Complaint.ComplaintObj.Name = Complaint[obj].typename;
                                this.TicketsSummery.Complaint.ComplaintObj.Values = Complaint[obj].totalcount;
                                this.TicketsSummery.Complaint.ComplaintObj.subResone = Complaint[obj].subreasonid;
                                this.TicketsSummery.Complaint.ComplaintData.push(this.TicketsSummery.Complaint.ComplaintObj);
                            }
                        }

                        var inqCount = 0;
                        var inqOtherCount = 0;
                        var inqOtherSubResone = [];
                        if (Inquiry.length > 0) {
                            for (let obj in Inquiry) {
                                total_inquiry = parseInt(total_inquiry) + parseInt(Inquiry[obj].totalcount);
                                this.TicketsSummery.Inquiry.TotalCound = total_inquiry;
                                inqCount = inqCount + 1;
                                this.TicketsSummery.Inquiry.InquiryObj = {};
                                this.TicketsSummery.Inquiry.InquiryObj.Name = Inquiry[obj].typename;
                                this.TicketsSummery.Inquiry.InquiryObj.Values = Inquiry[obj].totalcount;
                                this.TicketsSummery.Inquiry.InquiryObj.subResone = Inquiry[obj].subreasonid;
                                this.TicketsSummery.Inquiry.InquiryData.push(this.TicketsSummery.Inquiry.InquiryObj);
                            }
                        }

                        var reqCount = 0;
                        var reqOtherCount = 0;
                        var reqOtherSubResone = [];
                        if (Request.length > 0) {
                            for (let obj in Request) {
                                total_request = parseInt(total_request) + parseInt(Request[obj].totalcount);
                                this.TicketsSummery.Request.TotalCound = total_request;
                                reqCount = reqCount + 1;
                                this.TicketsSummery.Request.RequestObj = {};

                                this.TicketsSummery.Request.RequestObj.Name = Request[obj].typename;
                                this.TicketsSummery.Request.RequestObj.Values = Request[obj].totalcount;
                                this.TicketsSummery.Request.RequestObj.subResone = Request[obj].subreasonid;
                                this.TicketsSummery.Request.RequestData.push(this.TicketsSummery.Request.RequestObj);

                            }
                        }

                    }, error => {
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getTicketsSummery_Enquiry_Request_Complaint1";
                this.$alertify.error(msg);
            }
        },

        async getInboundLineChartData() {
            try {
                let token = 'Tu1ZyG';

                await axios({
                        method: 'POST',
                        url: apiUrl.crmivr_url + 'crmivr_live/IvrCallSummeryApi/getInboundCall_Hours_Wise',
                        datatype: 'json',
                        headers: commonFunction.getusertoken(),
                    })
                    .then(result => {

                        this.isLoadingInboundCallsTrend = false;
                        let resultDataCrm = result.data;
                        if (resultDataCrm.status == 'success') {

                            let resultData = result.data.data;

                            let hours = Array();
                            let AnsweredByCC = Array();
                            let TakenCareByIVR = Array();
                            let TotalCall = Array();
                            let RepeatCalls = Array();
                            let QueueFull = Array();
                            let MissedCall = Array();
                            let ChannelUnavailable = Array();
                            let HolidaySetting = Array();

                            let AnsweredByCCOBJ = {
                                name: 'Answered By CC',
                                data: AnsweredByCC,
                                color: '#7da144'
                            };

                            let TakenCareByIVROBJ = {
                                name: 'Taken Care By IVR',
                                data: TakenCareByIVR,
                                color: '#5C5C61'
                            };

                            let RepeatCallsOBJ = {
                                name: 'Repeat Calls',
                                data: RepeatCalls,
                                color: '#FFFF00'
                            };

                            let QueueFullOBJ = {
                                name: 'Queue Full',
                                data: QueueFull,
                                color: '#90ED7D'
                            };

                            let MissedCallOBJ = {
                                name: 'Missed Call',
                                data: MissedCall,
                                color: 'red'

                            };

                            let ChannelUnavailableOBJ = {
                                name: 'Channel Unavailable',
                                data: ChannelUnavailable,
                                color: '#F7A35C'
                            };

                            let HolidaySettingOBJ = {
                                name: 'Holiday Setting',
                                data: HolidaySetting,
                                color: '#999EFF'
                            };

                            for (let i = 0; i < resultData.length; i++) {
                                //console.log(resultData[i]);
                                hours[i] = resultData[i].hours;
                                AnsweredByCC[i] = parseInt(resultData[i].AnsweredByCC);
                                TakenCareByIVR[i] = parseInt(resultData[i].TakenCareByIVR);
                                TotalCall[i] = parseInt(resultData[i].TotalCall);
                                RepeatCalls[i] = parseInt(resultData[i].RepeatCalls);
                                QueueFull[i] = parseInt(resultData[i].QueueFull);
                                MissedCall[i] = parseInt(resultData[i].MissedCall);
                                ChannelUnavailable[i] = parseInt(resultData[i].ChannelUnavailable);
                                HolidaySetting[i] = parseInt(resultData[i].HolidaySetting);
                            }

                            this.chartLineOptions.xAxis.categories = hours;

                            // AnsweredByCCOBJ.name = 'Answered By CC';
                            // AnsweredByCCOBJ.data = AnsweredByCC;

                            // TakenCareByIVROBJ.name = 'Taken Care By IVR';
                            // TakenCareByIVROBJ.data = TakenCareByIVR;

                            // RepeatCallsOBJ.name = 'Repeat Calls';
                            // RepeatCallsOBJ.data = RepeatCalls;

                            // QueueFullOBJ.name = 'Queue Full';
                            // QueueFullOBJ.data = QueueFull;

                            // // MissedCallOBJ.name = 'Missed Calls';
                            // // MissedCallOBJ.data = MissedCall;

                            // ChannelUnavailableOBJ.name = 'Channel Unavailable';
                            // ChannelUnavailableOBJ.data = ChannelUnavailable;

                            // HolidaySettingOBJ.name = 'Holiday Setting';
                            // HolidaySettingOBJ.data = HolidaySetting;

                            this.chartLineOptions.series.push(TakenCareByIVROBJ);
                            this.chartLineOptions.series.push(AnsweredByCCOBJ);
                            this.chartLineOptions.series.push(MissedCallOBJ);
                            this.chartLineOptions.series.push(QueueFullOBJ);
                            this.chartLineOptions.series.push(ChannelUnavailableOBJ);
                            this.chartLineOptions.series.push(HolidaySettingOBJ);
                            this.chartLineOptions.series.push(RepeatCallsOBJ);


                        } else {
                            this.isLoadingInboundCallsTrend = false;
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        this.isLoadingInboundCallsTrend = false;
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getInboundLineChartData";
                this.$alertify.error(msg);
            }
        },

        async getInboundLineChartData_bk() {
            this.isLoadingInboundCallsTrend = true;
            let token = 'Tu1ZyG';
            await axios({
                    method: 'GET',
                    url: apiUrl.api_url + 'getInboundCall_Hours_Wise',
                    datatype: 'json',
                    headers: commonFunction.getusertoken(),
                })
                .then(result => {
                    this.isLoadingInboundCallsTrend = false;
                    let resultDataCrm = result.data.data;
                    if (resultDataCrm.status) {
                        let resultData = result.data.data.data.data;

                        let hours = Array();
                        let AnsweredByCC = Array();
                        let TakenCareByIVR = Array();
                        let TotalCall = Array();
                        let RepeatCalls = Array();
                        let QueueFull = Array();

                        let AnsweredByCCOBJ = {
                            name: '',
                            data: []
                        };

                        let TakenCareByIVROBJ = {
                            name: '',
                            data: []
                        };

                        let TotalCallOBJ = {
                            name: '',
                            data: []
                        };

                        let RepeatCallsOBJ = {
                            name: '',
                            data: []
                        };

                        let QueueFullOBJ = {
                            name: '',
                            data: []
                        };

                        for (let i = 0; i < resultData.length; i++) {

                            hours[i] = resultData[i].hours;
                            AnsweredByCC[i] = parseInt(resultData[i].AnsweredByCC);
                            TakenCareByIVR[i] = parseInt(resultData[i].TakenCareByIVR);
                            TotalCall[i] = parseInt(resultData[i].TotalCall);
                            RepeatCalls[i] = parseInt(resultData[i].RepeatCalls);
                            QueueFull[i] = parseInt(resultData[i].QueueFull);
                        }

                        this.chartLineOptions.xAxis.categories = hours;

                        AnsweredByCCOBJ.name = 'AnsweredByCC';
                        AnsweredByCCOBJ.data = AnsweredByCC;
                        TakenCareByIVROBJ.name = 'TakenCareByIVR';
                        TakenCareByIVROBJ.data = TakenCareByIVR;
                        TotalCallOBJ.name = 'TotalCall';
                        TotalCallOBJ.data = TotalCall;
                        RepeatCallsOBJ.name = 'RepeatCalls';
                        RepeatCallsOBJ.data = RepeatCalls;

                        QueueFullOBJ.name = 'QueueFull';
                        QueueFullOBJ.data = QueueFull;

                        this.chartLineOptions.series.push(AnsweredByCCOBJ);
                        this.chartLineOptions.series.push(TakenCareByIVROBJ);
                        this.chartLineOptions.series.push(TotalCallOBJ);
                        this.chartLineOptions.series.push(RepeatCallsOBJ);
                        this.chartLineOptions.series.push(QueueFullOBJ);

                    } else {
                        this.isLoadingInboundCallsTrend = false;
                        let msg = resultDataCrm.msg;
                        this.$alertify.error(msg);
                    }
                }, error => {
                    this.isLoadingInboundCallsTrend = false;
                    let msg = error;
                    this.$alertify.error(msg);
                });
        },

        async getNDRcallsLine_bk() {
            this.isLoadingNDRCallLineChart = true;
            let token = 'Tu1ZyG';
            await axios({
                    method: 'GET',
                    url: apiUrl.api_url + 'getNDRCalling_Hours_Wise',
                    datatype: 'json',
                    headers: commonFunction.getusertoken(),
                })
                .then(result => {
                    this.isLoadingNDRCallLineChart = false;
                    let resultDataCrm = result.data.data;
                    if (resultDataCrm.status) {
                        let resultData = result.data.data.data.data;

                        let hours = Array();
                        let AHT = Array();
                        let Success = Array();
                        let Failed = Array();
                        let totalCalls = Array();
                        let HoldTime = Array();
                        let Missed = Array();


                        let AHTOBJ = {
                            name: '',
                            data: []
                        };
                        let SuccessOBJ = {
                            name: '',
                            data: [],
                            color: '#96BA5D'
                        };
                        let FailedOBJ = {
                            name: '',
                            data: [],
                            color: '#000000'
                        };
                        let totalCallsOBJ = {
                            name: '',
                            data: [],
                            color: '#7CB5EC'
                        };
                        let HoldTimeOBJ = {
                            name: '',
                            data: []
                        };
                        let MissedOBJ = {
                            name: '',
                            data: [],
                            color: '#FF0000'
                        };


                        for (let i = 0; i < resultData.length; i++) {
                            AHT[i] = parseInt(resultData[i].AHT);
                            Success[i] = parseInt(resultData[i].Success);
                            Failed[i] = parseInt(resultData[i].Failed);
                            totalCalls[i] = parseInt(resultData[i].totalCalls);
                            hours[i] = parseInt(resultData[i].hours);
                            HoldTime[i] = parseInt(resultData[i].HoldTime);
                            Missed[i] = parseInt(resultData[i].Missed);
                        }

                        this.NDRcallsLine.xAxis.categories = hours;

                        AHTOBJ.name = 'AHT';
                        AHTOBJ.data = AHT;

                        SuccessOBJ.name = 'Success';
                        SuccessOBJ.data = Success;

                        FailedOBJ.name = 'Failed';
                        FailedOBJ.data = Failed;

                        totalCallsOBJ.name = 'totalCalls';
                        totalCallsOBJ.data = totalCalls;

                        HoldTimeOBJ.name = 'HoldTime';
                        HoldTimeOBJ.data = HoldTime;
                        MissedOBJ.name = 'Missed';
                        MissedOBJ.data = Missed;

                        //this.NDRcallsLine.series.push(AHTOBJ);
                        this.NDRcallsLine.series.push(SuccessOBJ);
                        this.NDRcallsLine.series.push(FailedOBJ);
                        this.NDRcallsLine.series.push(totalCallsOBJ);
                        this.NDRcallsLine.series.push(HoldTimeOBJ);
                        this.NDRcallsLine.series.push(MissedOBJ);

                    } else {
                        let msg = resultDataCrm.msg;
                        this.$alertify.error(msg);
                    }
                }, error => {
                    this.isLoadingNDRCallLineChart = false;
                    let msg = error;
                    this.$alertify.error(msg);
                });
        },

        async getMTDReattempt() {
            try {
                let token = 'Tu1ZyG';

                let today = new Date();
                let dd = today.getDate() + 1;
                let mm = today.getMonth() + 1;
                let yyyy = today.getFullYear();
                let date = yyyy + '-' + mm + '-' + dd;
                let firstday = yyyy + '-' + mm + '-' + "01";
                var businessflow = this.SummarySelectOptionObj.text;

                var userDepartmentId = await this.getUserDepartmet();

                var hubId = "";

                if (userDepartmentId == this.FieldOperationId) {
                    if (this.HubSelectOptionObj.value) {
                        hubId = (this.HubSelectOptionObj.value).toString();
                    }
                }

                var userClientName = "";
                if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport) {
                    var userClientNameStr = "";
                    userClientNameStr = this.clientlistOptionObj.text;
                    if (userClientNameStr) {
                    var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                    userClientName = "'" + userClientNameObj + "'";
                    if (userClientName == "'MULTIPLE'") {
                        var userClientName1 = window.localStorage.getItem('userclientNames');
                        userClientName = userClientName1;
                    } else if (userClientName == "'ALL'") {
                        userClientName = "";
                    } else if (userClientName == "''") {
                        userClientName = "'-1'";
                    }
                }
                }

                await axios({
                        method: 'POST',
                        url: apiUrl.api_url + 'getMTDReattempt',
                        datatype: 'json',
                        headers: commonFunction.getusertoken(),
                        data: {
                            toDate: firstday,
                            businessflow: businessflow,
                            hubId: hubId,
                            userClientName: userClientName
                        }
                    })
                    .then(result => {

                        let resultDataCrm = result.data.data;
                        this.MTDreatempt.series[0].data = [];
                        if (resultDataCrm.status) {
                            let resultData = result.data.data.data;

                            var result = 0;
                            if (resultData.Reattempt[0].totalReattempt && resultData.Delivered[0].totalReattemptDelivered > 0) {
                                result = parseInt((parseInt(resultData.Delivered[0].totalReattemptDelivered) / resultData.Reattempt[0].totalReattempt) * 100);
                            }
                            this.MTDreatempt.series[0].data.push(parseInt(result));

                        } else {
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        this.isLoading = false;
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getMTDReattempt";
                this.$alertify.error(msg);
            }
        },

        async getMTDEscalation() {
            try {
                let token = 'Tu1ZyG';
                let today = new Date();
                let dd = today.getDate() + 1;
                let mm = today.getMonth() + 1;
                let yyyy = today.getFullYear();
                let date = yyyy + '-' + mm + '-' + dd;
                let firstday = yyyy + '-' + mm + '-' + "01";
                var businessflow = this.SummarySelectOptionObj.text;

                var userDepartmentId = await this.getUserDepartmet();

                var hubId = "";

                if (userDepartmentId == this.FieldOperationId) {
                    if (this.HubSelectOptionObj.value) {
                        hubId = (this.HubSelectOptionObj.value).toString();
                    }
                }

                var userClientName = "";
                if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport) {
                    var userClientNameStr = "";
                    userClientNameStr = this.clientlistOptionObj.text;
                    if (userClientNameStr) {
                    var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                    userClientName = "'" + userClientNameObj + "'";
                    if (userClientName == "'MULTIPLE'") {
                        var userClientName1 = window.localStorage.getItem('userclientNames');
                        userClientName = userClientName1;
                    } else if (userClientName == "'ALL'") {
                        userClientName = "";
                    } else if (userClientName == "''") {
                        userClientName = "'-1'";
                    }
                }
                }
                await axios({
                        method: 'POST',
                        url: apiUrl.api_url + 'getMTDEscalation',
                        datatype: 'json',
                        headers: commonFunction.getusertoken(),
                        data: {
                            toDate: firstday,
                            businessflow: businessflow,
                            hubId: hubId,
                            userClientName: userClientName
                        }
                    })
                    .then(result => {

                        let resultDataCrm = result.data.data;
                        this.MTDEscalation.series[0].data = [];
                        if (resultDataCrm.status) {
                            let resultData = result.data.data.data;
                            //console.log(resultData);
                            var result = 0;
                            if (resultData.Reattempt[0].totalReattempt && resultData.Delivered[0].totalReattemptDelivered > 0) {
                                result = parseInt((parseInt(resultData.Delivered[0].totalReattemptDelivered) / resultData.Reattempt[0].totalReattempt) * 100);
                            }
                            this.MTDEscalation.series[0].data.push(parseInt(result));

                        } else {
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getMTDEscalation";
                this.$alertify.error(msg);
            }
        },

        async getPaginationData(pageNum) {
            try {
                this.isLoadingPagination = true;
                this.pageno = (pageNum - 1) * 10;
                await this.showSummaryTicketData(this.ticketname, this.hub, this.type);
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getPaginationData";
                this.$alertify.error(msg);
            }

        },

        async OnFilterClick(event) {
            try {
                this.pageno = 0;
                await this.showSummaryTicketData(this.ticketname, this.hub, this.type);
                if (this.pagecount > 1) {
                    this.$refs.paginate.selected = 0;
                }
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - OnFilterClick";
                this.$alertify.error(msg);
            }
        },

        async showSummaryTicketData1(ticketname, hub, type) {
            try {
                this.filter = '';
                this.isLoading = true;
                this.isLoadingPagination = true;
                await this.showSummaryTicketData(ticketname, hub, type);
                this.TicketsSummery.TicketTypeName = 'Ticket Details';
                this.TicketsSummery.Ticketsummerymodal = true;
                if (this.pagecount > 1) {
                    this.$refs.paginate.selected = 0;
                }
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - showSummaryTicketData1";
                this.$alertify.error(msg);
            }
        },

        showSummaryTicketData: async function (ticketname, hub, type) {
          this.showEditBulkButton=false;
          var permissiondataEncrypt = window.localStorage.getItem('permissiondata');
          var bytes = CryptoJS.AES.decrypt(permissiondataEncrypt.toString(), 'Key');
          var plaintext = bytes.toString(CryptoJS.enc.Utf8);
          var permissiondata = JSON.parse(plaintext);
          let bulkshipmentArr = permissiondata.filter(function (val) {
            return val.url == "/bulkshipment";
          });
            if(bulkshipmentArr.length == 1)
            {
            this.showEditBulkButton=true;
            }

            this.ticketname = ticketname;
            this.type = type;
            this.hub = hub;

            let condition = '';
            // var businessflow = this.SummarySelectOptionObj.text;

            var businessflow = 'Forward'

            this.TicketsSummery.TicketSummeryList = [];

            if (type == 'Complaint') {
                condition = " t.isescalation = 0 and t.tickettypeid=2 and t.deptid=16 and t.subreasonid IN (" + ticketname + ") and t.ticketstatus IN('Open', 'Follow Up') and t.businessflow = '" + businessflow + "' ";
            } else if (type == 'Request') {
                condition = "  t.isescalation = 0 and t.tickettypeid=3 and t.deptid=16 and t.subreasonid IN (" + ticketname + ") and t.ticketstatus IN('Open', 'Follow Up') and t.businessflow = '" + businessflow + "' ";
            } else if (type == 'Inquiry') {
                condition = " t.isescalation = 0 and t.tickettypeid=1 and t.deptid=16 and t.subreasonid IN (" + ticketname + ") and t.ticketstatus IN('Open', 'Follow Up')  and t.businessflow = '" + businessflow + "' ";
            }          
            else {
                condition = " t.createddate = date(now()) and t.businessflow = '" + businessflow + "' and t.ticketstatus IN('Open', 'Follow Up') ";
            }

            let userReporting = window.localStorage.getItem('userReporting');

            var userDepartmentId = await this.getUserDepartmet();

            this.useridBulk=userReporting;
            this.deptidBulk=userDepartmentId;

            var hubId = "";

            if (userDepartmentId == this.FieldOperationId) {
                if (this.HubSelectOptionObj.value) {
                    hubId = (this.HubSelectOptionObj.value).toString();
                }
            }
            var userClientName = "";
            if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport) {
                var userClientNameStr = "";
                userClientNameStr = this.clientlistOptionObj.text;
                if (userClientNameStr) {
                    var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                    userClientName = "'" + userClientNameObj + "'";
                    if (userClientName == "'MULTIPLE'") {
                        var userClientName1 = window.localStorage.getItem('userclientNames');
                        userClientName = userClientName1;
                    } else if (userClientName == "'ALL'") {
                        userClientName = "";
                    } else if (userClientName == "''") {
                        userClientName = "'-1'";
                    }
                }
            }
            const secretKey = constantVariable.enckey;
            const encryptedData = AES.encrypt(condition, secretKey).toString();
            const cleanEncryptedData = encryptedData.replace(/[=]/g, '_');
            this.userClientNameBulk=userClientName;
            await axios({
                    method: 'POST',
                    url: apiUrl.api_url + 'getTiketsListByTiketsType1',
                    data: {
                        conditions: cleanEncryptedData,
                        userid: userReporting,
                        userDepartmentId: userDepartmentId,
                        offset: this.pageno,
                        limit: 10,
                        searchData: this.filter,
                        hubId: hubId,
                        userClientName: userClientName
                    },
                    headers: commonFunction.getusertoken(),
                    datatype: 'json',
                })
                .then(result => {
                    let resultDataCrm = result.data.data;
                    if (resultDataCrm.status) {
                      let resultData = result.data.data.data;
                      if (resultData!=='') {
                        var limitNo = resultData[0].full_count;
                        const secretKey = constantVariable.enckey;
                        const encryptedData = AES.encrypt(condition, secretKey).toString();
                        const cleanEncryptedData = encryptedData.replace(/[=]/g, '_');
                        axios({
                              method: 'POST',
                              url: apiUrl.api_url + 'getTiketsListByTiketsType1',
                              data: {
                                  conditions: cleanEncryptedData,
                                  userid: userReporting,
                                  userDepartmentId: userDepartmentId,
                                  offset: this.pageno,
                                  limit: limitNo,
                                  searchData: this.filter,
                                  hubId: hubId,
                                  userClientName: userClientName
                              },
                              headers: commonFunction.getusertoken(),
                              datatype: 'json',
                          })
                          .then(resultarr => {
                              let resultarrinfo = resultarr.data.data;
                              if (resultarrinfo.status) {
                                let resultData = resultarr.data.data.data;
                                this.ticketSummeryListforBulkEdit = resultData;
                              }
                            }, error => {
                                this.isLoading = false;
                                let msg = error;
                                this.$alertify.error(msg);
                            });
                        }
                        // this.ticketSummeryListforBulkEdit = resultData;
                        // console.log("resultData---",result);
                        // console.log("ticketSummeryListforBulkEdit-----",this.ticketSummeryListforBulkEdit);
                        this.TicketsSummery.TicketSummeryList = [];
                        for (let i = 0; i < resultData.length; i++) {
                            this.TicketsSummery.TicketSummeryListEel = {};
                            // var cData = '';
                            // if (resultData[i].createddate) {
                            //     let today = new Date(resultData[i].createddate);
                            //     let dd = today.getDate();
                            //     let mm = today.getMonth() + 1;
                            //     let yyyy = today.getFullYear();
                            //     cData = dd + '-' + mm + '-' + yyyy;
                            // }

                            var rData = '';
                            if (resultData[i].reattemptdate) {
                                let today1 = new Date(resultData[i].reattemptdate);
                                let dd1 = today1.getDate();
                                let mm1 = today1.getMonth() + 1;
                                let yyyy1 = today1.getFullYear();
                                rData = dd1 + '-' + mm1 + '-' + yyyy1;
                            }
                            this.TicketsSummery.TicketSummeryListEel.shippingid = (resultData[i].shippingid == null) ? '-' : resultData[i].shippingid;
                            this.TicketsSummery.TicketSummeryListEel.ticketid = (resultData[i].ticketid == null) ? '-' : resultData[i].ticketid;
                            this.TicketsSummery.TicketSummeryListEel.pincode = (resultData[i].pincode == null) ? '-' : resultData[i].pincode;
                            this.TicketsSummery.TicketSummeryListEel.createddate = (resultData[i].createddate == null) ? '-' : resultData[i].createddate;
                            this.TicketsSummery.TicketSummeryListEel.createdby = (resultData[i].createdby == null) ? '-' : resultData[i].createdby;
                            this.TicketsSummery.TicketSummeryListEel.ticketstatus = (resultData[i].ticketstatus == null) ? '-' : resultData[i].ticketstatus;
                            this.TicketsSummery.TicketSummeryListEel.reattemptdate = rData; //(resultData[i].reattemptdate == null) ? '-' : resultData[i].reattemptdate;
                            this.TicketsSummery.TicketSummeryListEel.reasonid = (resultData[i].maintype == null) ? '-' : resultData[i].maintype;
                            this.TicketsSummery.TicketSummeryListEel.sourceid = (resultData[i].source == null) ? '-' : resultData[i].source;
                            this.TicketsSummery.TicketSummeryListEel.subreasonid = (resultData[i].typename == null) ? '-' : resultData[i].typename;

                            this.TicketsSummery.TicketSummeryList.push(this.TicketsSummery.TicketSummeryListEel);
                        }

                        if (resultData.length > 0) {
                            var totalRows = resultData[0].full_count;
                            if (totalRows < 10) {
                                this.pagecount = 1;
                                this.pageno = 0;
                            } else {
                                this.pagecount = Math.ceil(totalRows / 10)
                            }
                        } else {
                            this.pagecount = 0;
                        }

                    }
                    this.isLoading = false;
                    this.isLoadingPagination = false;
                }, error => {
                    this.isLoading = false;
                    this.isLoadingPagination = false;
                    let msg = error;
                    this.$alertify.error(msg);
                });
            this.isLoading = false;
            this.isLoadingPagination = false;
        },

        closeTicketsummerymodal() {
            this.pageno = 0;
            this.TicketsSummery.Ticketsummerymodal = false;
        },

        showTicketDataLocationWise: async function (hubname, hub, ttype) {
            if (hubname != "") {
                let condition = "";
                var businessflow = this.SummarySelectOptionObj.text;
                if (ttype == "Complaint") {
                    condition = " t.businessflow = '" + businessflow + "' and t.tickettypeid = 2 and t.isescalation = 0 and t.hub = '" + hubname + "' and t.ticketstatus IN('Open', 'Follow Up')  ";
                } else if (ttype == "Escalation") {
                    condition = "t.businessflow = '" + businessflow + "' and t.isescalation = 1 and t.hub = '" + hubname + "' and t.ticketstatus IN('Open', 'Follow Up')  ";
                }
                this.TicketsSummery.TicketSummeryList = [];

                let userReporting = window.localStorage.getItem('userReporting');

                var userDepartmentId = await this.getUserDepartmet();
                var hubId = "";

                if (userDepartmentId == this.FieldOperationId) {
                    if (this.HubSelectOptionObj.value) {
                        hubId = (this.HubSelectOptionObj.value).toString();
                    }
                }
                var userClientName = "";
                if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport) {
                    var userClientNameStr = "";
                    userClientNameStr = this.clientlistOptionObj.text;
                    if (userClientNameStr) {
                    var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                    userClientName = "'" + userClientNameObj + "'";
                    if (userClientName == "'MULTIPLE'") {
                        var userClientName1 = window.localStorage.getItem('userclientNames');
                        userClientName = userClientName1;
                    } else if (userClientName == "'ALL'") {
                        userClientName = "";
                    } else if (userClientName == "''") {
                        userClientName = "'-1'";
                    }
                }
                }
                const secretKey = constantVariable.enckey;
                const encryptedData = AES.encrypt(condition, secretKey).toString();
                const cleanEncryptedData = encryptedData.replace(/[=]/g, '_');
                axios({
                        method: 'POST',
                        url: apiUrl.api_url + 'getTiketsListByTiketsType1',
                        data: {
                            conditions: cleanEncryptedData,
                            userid: userReporting,
                            userDepartmentId: userDepartmentId,
                            hubId: hubId,
                            userClientName: userClientName
                        },
                        headers: commonFunction.getusertoken(),
                        datatype: 'json',
                    })
                    .then(result => {


                        let resultDataCrm = result.data.data;
                        if (resultDataCrm.status) {
                            let resultData = result.data.data.data;
                            this.TicketsSummery.TicketSummeryList = [];
                            for (let i = 0; i < resultData.length; i++) {

                                this.TicketsSummery.TicketSummeryListEel = {};

                                this.TicketsSummery.TicketSummeryListEel.shippingid = (resultData[i].shippingid == null) ? '-' : resultData[i].shippingid;
                                this.TicketsSummery.TicketSummeryListEel.ticketid = (resultData[i].ticketid == null) ? '-' : resultData[i].ticketid;
                                this.TicketsSummery.TicketSummeryListEel.pincode = (resultData[i].pincode == null) ? '-' : resultData[i].pincode;
                                this.TicketsSummery.TicketSummeryListEel.createddate = (resultData[i].createddate == null) ? '-' : resultData[i].createddate;
                                this.TicketsSummery.TicketSummeryListEel.ticketstatus = (resultData[i].ticketstatus == null) ? '-' : resultData[i].ticketstatus;
                                this.TicketsSummery.TicketSummeryListEel.reattemptdate = (resultData[i].reattemptdate == null) ? '-' : resultData[i].reattemptdate;
                                this.TicketsSummery.TicketSummeryListEel.reasonid = (resultData[i].maintype == null) ? '-' : resultData[i].maintype;
                                this.TicketsSummery.TicketSummeryListEel.sourceid = (resultData[i].source == null) ? '-' : resultData[i].source;
                                this.TicketsSummery.TicketSummeryListEel.subreasonid = (resultData[i].subtype == null) ? '-' : resultData[i].subtype;

                                this.TicketsSummery.TicketSummeryList.push(this.TicketsSummery.TicketSummeryListEel);
                            }
                        }

                    }, error => {
                        let msg = error;
                        this.$alertify.error(msg);
                    });

                this.TicketsSummery.TicketTypeName = 'Location Name: ' + hub;
                this.TicketsSummery.Ticketsummerymodal = true;
            } else {
                console.log(" Can't open list, Hub name is wrong! ");
            }
        },

        showTwitterTickets: async function (maintype) {
            // console.log(maintype);
            var businessflow = this.SummarySelectOptionObj.text;

            if (maintype != "") {
                let condition = '';
                if (maintype == 'Enquiry') {
                    condition = "  t.sourceid = 5 and t.tickettypeid = 1 and t.businessflow = '" + businessflow + "' and t.ticketstatus IN('Open', 'Follow Up')";
                } else if (maintype == 'Complaint') {
                    condition = "  t.sourceid = 5 and t.tickettypeid = 2  and t.businessflow = '" + businessflow + "' and t.ticketstatus IN('Open', 'Follow Up')  ";
                } else if (maintype == 'Request') {
                    condition = "  t.sourceid=5 and t.tickettypeid = 3  and t.businessflow = '" + businessflow + "'  and t.ticketstatus IN('Open', 'Follow Up')  ";
                } else if (maintype == 'Complaint_fake') {
                    let today = new Date();
                    let dd = today.getDate();
                    let mm = today.getMonth() + 1;
                    let yyyy = today.getFullYear();
                    let date = yyyy + '-' + mm + '-' + dd;

                    condition = "  t.tickettypeid=2 and reasonid = 6 and subreasonid=22 and t.createddate >= '" + date + "' and t.businessflow = '" + businessflow + "' and t.ticketstatus IN('Open', 'Follow Up') ";
                } else if (maintype == 'Complaint_MTDfake') {
                    let today = new Date();
                    let dd = today.getDate();
                    let mm = today.getMonth() + 1;
                    let yyyy = today.getFullYear();
                    let date = yyyy + '-' + mm + '-01';
                    condition = "  t.tickettypeid=2 and reasonid = 6 and subreasonid=22 and t.createddate >= '" + date + "' and t.businessflow = '" + businessflow + "' and t.ticketstatus IN('Open', 'Follow Up')  ";

                } else {
                    condition = " t.createddate = date(now()) and t.businessflow = '" + businessflow + "' and t.ticketstatus IN('Open', 'Follow Up') ";
                }

                this.TicketsSummery.TicketSummeryList = [];
                let userReporting = window.localStorage.getItem('userReporting');
                var userDepartmentId = await this.getUserDepartmet();

                var hubId = "";

                if (userDepartmentId == this.FieldOperationId) {
                    if (this.HubSelectOptionObj.value) {
                        hubId = (this.HubSelectOptionObj.value).toString();
                    }
                }
                var userClientName = "";
                if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport) {
                    var userClientNameStr = "";
                    userClientNameStr = this.clientlistOptionObj.text;
                    if (userClientNameStr) {
                    var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                    userClientName = "'" + userClientNameObj + "'";
                    if (userClientName == "'MULTIPLE'") {
                        var userClientName1 = window.localStorage.getItem('userclientNames');
                        userClientName = userClientName1;
                    } else if (userClientName == "'ALL'") {
                        userClientName = "";
                    } else if (userClientName == "''") {
                        userClientName = "'-1'";
                    }
                }
                }
                const secretKey = constantVariable.enckey;
                const encryptedData = AES.encrypt(condition, secretKey).toString();
                const cleanEncryptedData = encryptedData.replace(/[=]/g, '_');
                await axios({
                        method: 'POST',
                        url: apiUrl.api_url + 'getTiketsListByTiketsType1',
                        data: {
                            conditions: cleanEncryptedData,
                            userid: userReporting,
                            userDepartmentId: userDepartmentId,
                            hubId: hubId,
                            userClientName: userClientName
                        },
                        headers: commonFunction.getusertoken(),
                        datatype: 'json',
                    })
                    .then(result => {
                        let resultDataCrm = result.data.data;
                        if (resultDataCrm.status) {
                            let resultData = result.data.data.data;
                            this.TicketsSummery.TicketSummeryList = [];
                            for (let i = 0; i < resultData.length; i++) {

                                this.TicketsSummery.TicketSummeryListEel = {};

                                this.TicketsSummery.TicketSummeryListEel.shippingid = (resultData[i].shippingid == null) ? '-' : resultData[i].shippingid;
                                this.TicketsSummery.TicketSummeryListEel.ticketid = (resultData[i].ticketid == null) ? '-' : resultData[i].ticketid;
                                this.TicketsSummery.TicketSummeryListEel.pincode = (resultData[i].pincode == null) ? '-' : resultData[i].pincode;
                                this.TicketsSummery.TicketSummeryListEel.createddate = (resultData[i].createddate == null) ? '-' : resultData[i].createddate;
                                this.TicketsSummery.TicketSummeryListEel.ticketstatus = (resultData[i].ticketstatus == null) ? '-' : resultData[i].ticketstatus;
                                this.TicketsSummery.TicketSummeryListEel.reattemptdate = (resultData[i].reattemptdate == null) ? '-' : resultData[i].reattemptdate;
                                this.TicketsSummery.TicketSummeryListEel.reasonid = (resultData[i].maintype == null) ? '-' : resultData[i].maintype;
                                this.TicketsSummery.TicketSummeryListEel.sourceid = (resultData[i].source == null) ? '-' : resultData[i].source;
                                this.TicketsSummery.TicketSummeryListEel.subreasonid = (resultData[i].subtype == null) ? '-' : resultData[i].subtype;

                                this.TicketsSummery.TicketSummeryList.push(this.TicketsSummery.TicketSummeryListEel);
                            }
                        }
                    }, error => {
                        let msg = error;
                        this.$alertify.error(msg);
                    });

                this.TicketsSummery.TicketTypeName = 'Ticket Details';
                this.TicketsSummery.Ticketsummerymodal = true;
            } else {
                console.log(" Can't open list, Ticket Type is wrong! ");
            }
        },

        async getTop_5_Locations_Complaint() {
            try {
                this.TicketsSummery.TopLocations.Toplocation = []; // myCode
                this.isLoadingTopLocationsComplaint = true;
                let token = 'Tu1ZyG';
                let userReporting = window.localStorage.getItem('userReporting');
                var businessflow = this.SummarySelectOptionObj.text;
                var userDepartmentId = await this.getUserDepartmet();
                var hubId = "";

                if (userDepartmentId == this.FieldOperationId) {
                    if (this.HubSelectOptionObj.value) {
                        hubId = (this.HubSelectOptionObj.value).toString();
                    }
                }

                var userClientName = "";
                if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport) {
                    var userClientNameStr = "";
                    userClientNameStr = this.clientlistOptionObj.text;
                    if (userClientNameStr) {
                        var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                        userClientName = "'" + userClientNameObj + "'";
                        if (userClientName == "'MULTIPLE'") {
                            var userClientName1 = window.localStorage.getItem('userclientNames');
                            userClientName = userClientName1;
                        } else if (userClientName == "'ALL'") {
                            userClientName = "";
                        } else if (userClientName == "''") {
                            userClientName = "'-1'";
                        }
                    }

                }
                const secretKey = constantVariable.enckey;
                const encryptedData = AES.encrypt(userReporting, secretKey).toString();
                let ecuserReporting = encryptedData.replace(/[=]/g, '_');
                await axios({
                        method: 'POST',
                        url: apiUrl.api_url + 'getTop_5_Locations_Complaint',
                        datatype: 'json',
                        headers: commonFunction.getusertoken(),
                        data: {
                            userid: ecuserReporting,
                            userDepartmentId: userDepartmentId,
                            businessflow: businessflow,
                            hubId: hubId,
                            userClientName: userClientName
                        }
                    })
                    .then(async result => {
                        this.TicketsSummery.TopLocations.Toplocation = []; // myCode
                        this.isLoadingTopLocationsComplaint = false;
                        let resultDataCrm = result.data.data;
                        if (resultDataCrm.status) {
                            let resultData = result.data.data.data;
                            this.TicketsSummery.TopLocations.ToplocationCount = resultData.length

                            for (let i = 0; i < resultData.length; i++) {

                                if (resultData[i].hub) {
                                  this.TicketsSummery.TopLocations.Toplocationele = {};  // myCode
                                  const secretKey = constantVariable.enckey;
                                  const encryptedData = AES.encrypt(resultData[i].hub, secretKey).toString();
                                  let ecdata = encryptedData.replace(/[=]/g, '_');
                                    this.input = ({
                                        id: ecdata
                                    })

                                    await axios({
                                            method: 'POST',
                                            'url': apiUrl.api_url + 'getHubDetailById',
                                            'headers': commonFunction.getusertoken(),
                                            'data': this.input
                                        })
                                        .then(result1 => {
                                            this.TicketsSummery.TopLocations.Toplocationele = {};
                                            var d = result1.data.data.data.data;
                                            let hubName = '';
                                            if (d) {
                                                hubName = result1.data.data.data.data[0].HubName;
                                            }
                                            this.TicketsSummery.TopLocations.Toplocationele.hub = resultData[i].hub;
                                            this.TicketsSummery.TopLocations.Toplocationele.hubname = hubName;
                                            this.TicketsSummery.TopLocations.Toplocationele.total_count = (resultData[i].total_count == null) ? '0' : resultData[i].total_count;
                                            // myCode
                                            const found = this.TicketsSummery.TopLocations.Toplocation.some(el => el.hub === this.TicketsSummery.TopLocations.Toplocationele.hub);
                                            if (!found)  this.TicketsSummery.TopLocations.Toplocation.push(this.TicketsSummery.TopLocations.Toplocationele);

                                          // this.TicketsSummery.TopLocations.Toplocation.push(this.TicketsSummery.TopLocations.Toplocationele);
                                        });
                                }
                            }
                        } else {
                            this.isLoadingTopLocationsComplaint = false;
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        this.isLoading = false;
                        this.isLoadingTopLocationsComplaint = false;
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getTop_5_Locations_Complaint";
                this.$alertify.error(msg);
            }
        },

        async getTop_5_Locations_Escalation() {
            try {
                this.isLoadingTopLocationsEscalation = true;
                let token = 'Tu1ZyG';

                let userReporting = window.localStorage.getItem('userReporting');
                var businessflow = this.SummarySelectOptionObj.text;
                var userDepartmentId = await this.getUserDepartmet();
                var hubId = "";

                if (userDepartmentId == this.FieldOperationId) {
                    if (this.HubSelectOptionObj.value) {
                        hubId = (this.HubSelectOptionObj.value).toString();
                    }
                }
                var userClientName = "";
                if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport) {
                    var userClientNameStr = "";
                    userClientNameStr = this.clientlistOptionObj.text;
                    if (userClientNameStr) {
                    var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                    userClientName = "'" + userClientNameObj + "'";
                    if (userClientName == "'MULTIPLE'") {
                        var userClientName1 = window.localStorage.getItem('userclientNames');
                        userClientName = userClientName1;
                    } else if (userClientName == "'ALL'") {
                        userClientName = "";
                    } else if (userClientName == "''") {
                        userClientName = "'-1'";
                    }
                }

                }
                this.TicketsSummery.TopLocations.ToplocationEscalation = [];
                const secretKey = constantVariable.enckey;
                const encryptedData = AES.encrypt(userReporting, secretKey).toString();
                let ecuserReporting = encryptedData.replace(/[=]/g, '_');
                await axios({
                        method: 'POST',
                        url: apiUrl.api_url + 'getTop_5_Locations_Escalation',
                        datatype: 'json',
                        headers: commonFunction.getusertoken(),
                        data: {
                            userid: ecuserReporting,
                            userDepartmentId: userDepartmentId,
                            businessflow: businessflow,
                            hubId: hubId,
                            userClientName: userClientName
                        }
                    })
                    .then(async result => {
                        this.TicketsSummery.TopLocations.ToplocationEscalation = []; //myCode
                        this.isLoadingTopLocationsEscalation = false;
                        let resultDataCrm = result.data.data;
                        if (resultDataCrm.status) {
                            let resultData = result.data.data.data;
                            this.TicketsSummery.TopLocations.TopEscalationCount = resultData.length;
                            for (let i = 0; i < resultData.length; i++) {
                                if (resultData[i].hub) {
                                    const secretKey = constantVariable.enckey;
                                    const encryptedData = AES.encrypt(resultData[i].hub, secretKey).toString();
                                    let ecdata = encryptedData.replace(/[=]/g, '_');
                                    this.input = ({
                                        id: ecdata
                                    })

                                    await axios({
                                            method: 'POST',
                                            'url': apiUrl.api_url + 'getHubDetailById',
                                            'headers': commonFunction.getusertoken(),
                                            'data': this.input
                                        })
                                        .then(result1 => {

                                            this.TicketsSummery.TopLocations.ToplocationEscalationele = {};
                                            var d = result1.data.data.data.data;
                                            let hubName = '';
                                            if (d) {
                                                hubName = result1.data.data.data.data[0].HubName;
                                            }

                                            this.TicketsSummery.TopLocations.ToplocationEscalationele.hub = resultData[i].hub;
                                            this.TicketsSummery.TopLocations.ToplocationEscalationele.hubname = hubName;
                                            this.TicketsSummery.TopLocations.ToplocationEscalationele.total_count = (resultData[i].total_count == null) ? '0' : resultData[i].total_count;

                                            // myCode
                                            const found = this.TicketsSummery.TopLocations.ToplocationEscalation.some(el => el.hub === this.TicketsSummery.TopLocations.ToplocationEscalationele.hub);
                                            if (!found)  this.TicketsSummery.TopLocations.ToplocationEscalation.push(this.TicketsSummery.TopLocations.ToplocationEscalationele);

                                            // this.TicketsSummery.TopLocations.ToplocationEscalation.push(this.TicketsSummery.TopLocations.ToplocationEscalationele);
                                        });
                                }
                            }
                        } else {
                            this.isLoadingTopLocationsEscalation = false;
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        this.isLoadingTopLocationsEscalation = false;
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getTop_5_Locations_Escalation";
                this.$alertify.error(msg);
            }
        },

        async getTwitterTickets() {
            try {
                let userReporting = window.localStorage.getItem('userReporting');
                var businessflow = this.SummarySelectOptionObj.text;
                var userDepartmentId = await this.getUserDepartmet();
                var hubId = "";

                if (userDepartmentId == this.FieldOperationId) {
                    if (this.HubSelectOptionObj.value) {
                        hubId = (this.HubSelectOptionObj.value).toString();
                    }
                }

                var userClientName = "";
                if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport) {
                    var userClientNameStr = "";
                    userClientNameStr = this.clientlistOptionObj.text;
                    if (userClientNameStr) {
                    var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                    userClientName = "'" + userClientNameObj + "'";
                    if (userClientName == "'MULTIPLE'") {
                        var userClientName1 = window.localStorage.getItem('userclientNames');
                        userClientName = userClientName1;
                    } else if (userClientName == "'ALL'") {
                        userClientName = "";
                    } else if (userClientName == "''") {
                        userClientName = "'-1'";
                    }
                }
                }

                await axios({
                        method: 'POST',
                        url: apiUrl.api_url + 'getTwitterTickets',
                        headers: commonFunction.getusertoken(),
                        datatype: 'json',
                        data: {
                            userid: userReporting,
                            userDepartmentId: userDepartmentId,
                            businessflow: businessflow,
                            hubId: hubId,
                            userClientName: userClientName
                        }
                    })
                    .then(result => {
                        this.isLoadingTwitterTickets = false;
                        let resultDataCrm = result.data.data;
                        if (resultDataCrm.status) {
                            let resultData = result.data.data.data;
                            //console.log(result.data.data.data.Inquiry[0]);

                            this.TicketsSummery.TwitterTickets.TwitterTicketEle = {};
                            this.TicketsSummery.TwitterTickets.TwitterTicketEle.maintype = 'Enquiry';
                            this.TicketsSummery.TwitterTickets.TwitterTicketEle.total_count = (resultData.Inquiry[0].Inquiry == null) ? '0' : resultData.Inquiry[0].Inquiry;
                            this.TicketsSummery.TwitterTickets.TwitterTicket.push(this.TicketsSummery.TwitterTickets.TwitterTicketEle);

                            this.TicketsSummery.TwitterTickets.TwitterTicketEle = {};
                            this.TicketsSummery.TwitterTickets.TwitterTicketEle.maintype = 'Request';
                            this.TicketsSummery.TwitterTickets.TwitterTicketEle.total_count = (resultData.Complaint[0].Request == null) ? '0' : resultData.Complaint[0].Request;
                            this.TicketsSummery.TwitterTickets.TwitterTicket.push(this.TicketsSummery.TwitterTickets.TwitterTicketEle);

                            this.TicketsSummery.TwitterTickets.TwitterTicketEle = {};
                            this.TicketsSummery.TwitterTickets.TwitterTicketEle.maintype = 'Complaint';
                            this.TicketsSummery.TwitterTickets.TwitterTicketEle.total_count = (resultData.Complaint[0].Complaint == null) ? '0' : resultData.Complaint[0].Complaint;
                            this.TicketsSummery.TwitterTickets.TwitterTicket.push(this.TicketsSummery.TwitterTickets.TwitterTicketEle);
                        } else {
                            this.isLoadingTwitterTickets = false;
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        this.isLoadingTwitterTickets = false;
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getTwitterTickets";
                this.$alertify.error(msg);
            }
        },

        async getCancellationReasons() {
            try {
                this.isLoadingCancellationReasons = true;
                let userReporting = window.localStorage.getItem('userReporting');
                var type = this.SummarySelectOptionObj.text;
                var userDepartmentId = await this.getUserDepartmet();
                var hubId = "";

                if (userDepartmentId == this.FieldOperationId) {
                    if (this.HubSelectOptionObj.value) {
                        hubId = (this.HubSelectOptionObj.value).toString();
                    }
                }

                var userClientName = "";
                if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport) {
                    var userClientNameStr = "";
                    userClientNameStr = this.clientlistOptionObj.text;
                    if (userClientNameStr) {
                    var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                    userClientName = "'" + userClientNameObj + "'";
                    if (userClientName == "'MULTIPLE'") {
                        var userClientName1 = window.localStorage.getItem('userclientNames');
                        userClientName = userClientName1;
                    } else if (userClientName == "'ALL'") {
                        userClientName = "";
                    } else if (userClientName == "''") {
                        userClientName = "'-1'";
                    }
                }
                }

                let today = new Date();
                let dd = today.getDate() + 1;
                let mm = today.getMonth() + 1;
                let yyyy = today.getFullYear();
                let date = yyyy + '-' + mm + '-' + dd;
                let firstday = yyyy + '-' + mm + '-' + "01";
                const secretKey = constantVariable.enckey;
                const encryptedData = AES.encrypt(userReporting, secretKey).toString();
                let ecuserReporting = encryptedData.replace(/[=]/g, '_');

                await axios({
                        method: 'POST',
                        url: apiUrl.api_url + 'getCancellationReasons',
                        headers: commonFunction.getusertoken(),
                        datatype: 'json',
                        data: {
                            userid: ecuserReporting,
                            userDepartmentId: userDepartmentId,
                            toDate: firstday,
                            type: type,
                            hubId: hubId,
                            userClientName: userClientName
                        }
                    })
                    .then(result => {
                        this.isLoadingCancellationReasons = false;
                        let resultDataCrm = result.data.data;
                        if (resultDataCrm.status) {
                            let resultData = result.data.data.data;

                            let result_ = {

                                data: [],

                                innerSize: '45%',
                                showInLegend: true,
                                dataLabels: {
                                    enabled: true,
                                    format: '{point.percentage:.1f} %',
                                    distance: -22,
                                    filter: {
                                        property: 'percentage',
                                        operator: '>',
                                        value: 4
                                    }
                                }
                            };
                            this.CancellationReasons.totalCount = 0;
                            this.CancellationReasons.totalCount = resultData.length;
                            this.CancellationReasons.series = [];
                            for (let i = 0; i < resultData.length; i++) {
                                let data_ = Array();
                                data_.push(resultData[i].typename);
                                data_.push(parseInt(resultData[i].total_count));
                                result_.data.push(data_);

                            }
                            this.CancellationReasons.series.push(result_);
                        } else {
                            this.isLoadingCancellationReasons = false;
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        this.isLoading = false;
                        this.isLoadingCancellationReasons = false;
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getCancellationReasons";
                this.$alertify.error(msg);
            }
        },

        async getFakeResoneTicket() {
            try {
                let today = new Date();
                let dd = today.getDate();
                let mm = today.getMonth() + 1;
                let yyyy = today.getFullYear();
                let date = yyyy + '-' + mm + '-' + dd;

                let userReporting = window.localStorage.getItem('userReporting');
                var userDepartmentId = await this.getUserDepartmet();
                var hubId = "";

                if (userDepartmentId == this.FieldOperationId) {
                    if (this.HubSelectOptionObj.value) {
                        hubId = (this.HubSelectOptionObj.value).toString();
                    }
                }

                var userClientName = "";
                if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport) {
                    var userClientNameStr = "";
                    userClientNameStr = this.clientlistOptionObj.text;
                    if (userClientNameStr) {
                    var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                    userClientName = "'" + userClientNameObj + "'";
                    if (userClientName == "'MULTIPLE'") {
                        var userClientName1 = window.localStorage.getItem('userclientNames');
                        userClientName = userClientName1;
                    } else if (userClientName == "'ALL'") {
                        userClientName = "";
                    } else if (userClientName == "''") {
                        userClientName = "'-1'";
                    }
                }
                }

                var businessflow = this.SummarySelectOptionObj.text;
                await axios({
                        method: 'POST',
                        url: apiUrl.api_url + 'getFakeResoneTicket',
                        headers: commonFunction.getusertoken(),
                        datatype: 'json',
                        data: {
                            fdate: date,
                            userid: userReporting,
                            userDepartmentId: userDepartmentId,
                            businessflow: businessflow,
                            hubId: hubId,
                            userClientName: userClientName
                        }
                    })
                    .then(result => {
                        this.isLoadingOutboundContactFack = false;
                        let resultDataCrm = result.data.data;
                        if (resultDataCrm.status) {
                            let resultData = result.data.data.data;
                            this.OutBoundContactCenter.Fake = (resultData[0].total_count == "" || resultData[0].total_count == null) ? '0' : resultData[0].total_count;

                        } else {
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        this.isLoading = false;
                        this.isLoadingOutboundContactFack = false;
                        var commonVariable = commonFunction.showNetworkError(error);
                        this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getFakeResoneTicket";
                this.$alertify.error(msg);
            }
        },

        async getMTDFakeResoneTicket() {
            try {
                let today = new Date();
                let dd = today.getDate();
                let mm = today.getMonth() + 1;
                let yyyy = today.getFullYear();
                let date = yyyy + '-' + mm + '-01';
                let userReporting = window.localStorage.getItem('userReporting');
                var userDepartmentId = await this.getUserDepartmet();
                var hubId = "";

                if (userDepartmentId == this.FieldOperationId) {
                    if (this.HubSelectOptionObj.value) {
                        hubId = (this.HubSelectOptionObj.value).toString();
                    }
                }
                var userClientName = "";
                if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport) {
                    var userClientNameStr = "";
                    userClientNameStr = this.clientlistOptionObj.text;
                    if (userClientNameStr) {
                    var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                    userClientName = "'" + userClientNameObj + "'";
                    if (userClientName == "'MULTIPLE'") {
                        var userClientName1 = window.localStorage.getItem('userclientNames');
                        userClientName = userClientName1;
                    } else if (userClientName == "'ALL'") {
                        userClientName = "";
                    } else if (userClientName == "''") {
                        userClientName = "'-1'";
                    }
                }
                }

                var businessflow = this.SummarySelectOptionObj.text;
                await axios({
                        method: 'POST',
                        url: apiUrl.api_url + 'getFakeResoneTicket',
                        headers: commonFunction.getusertoken(),
                        datatype: 'json',
                        data: {
                            fdate: date,
                            userid: userReporting,
                            userDepartmentId: userDepartmentId,
                            businessflow: businessflow,
                            hubId: hubId,
                            userClientName: userClientName
                        }
                    })
                    .then(result => {
                        this.isLoadingOutBoundMTDContactCenterFack = false;
                        let resultDataCrm = result.data.data;
                        if (resultDataCrm.status) {
                            let resultData = result.data.data.data;
                            this.OutBoundMTDContactCenter.Fake = (resultData[0].total_count == "" || resultData[0].total_count == null) ? '0' : resultData[0].total_count;

                        } else {
                            let msg = resultDataCrm.msg;
                            this.$alertify.error(msg);
                        }
                    }, error => {
                        this.isLoadingOutBoundMTDContactCenterFack = false;
                        let msg = error;
                        this.$alertify.error(msg);
                    });
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - getMTDFakeResoneTicket";
                this.$alertify.error(msg);
            }
        },

        async getUserDepartmet() {
            return new Promise((resolve, reject) => {
                var userDepartmentId = "";
                var deptData = window.localStorage.getItem(
                    "userSubDepartmentId"
                );

                if (deptData) {
                    var userSubDepartmentId = JSON.parse(deptData);
                    userDepartmentId = userSubDepartmentId.value;
                }

                if (userDepartmentId) {
                    resolve(userDepartmentId);
                } else {
                    resolve('-1');
                }
            });
        },

        async getCSAWStatusSummary() {
                     try {
                this.CSAWStatusSummaryLoading = true;
                /*
                let today = new Date();
                let dd = today.getDate();
                let mm = today.getMonth() + 1;
                let yyyy = today.getFullYear();
                let date = yyyy + '-' + mm + '-01';
*/

var indiaTimedate = new Date().toLocaleString("en-US", {
    timeZone: "Asia/Kolkata"
  });
  var dateIndia = new Date(indiaTimedate);
  var date = dateIndia.getFullYear() + "-" + ("00" + (dateIndia.getMonth() + 1)).slice(-2) + "-" + ("00" + dateIndia.getDate()).slice(-2);
//  var currentTime = ("00" + dateIndia.getHours()).slice(-2) + ":" + ("00" + dateIndia.getMinutes()).slice(-2) + ":" + ("00" + dateIndia.getSeconds()).slice(-2);
 // var currentDateTime = currentDate + " " + currentTime;
 // console.log("currentDate ", date);



                let userReporting = window.localStorage.getItem('userReporting');
                var userDepartmentId = await this.getUserDepartmet();
                var hubId = "";

                if (userDepartmentId == this.FieldOperationId) {
                    if (this.HubSelectOptionObj.value) {
                        hubId = this.HubSelectOptionObj.value;
                    }
                }

                var userClientName = "";
                if (userDepartmentId == this.FwdClientSupport || userDepartmentId == this.RvpClientSupport) {
                    var userClientNameStr = "";
                    userClientNameStr = this.clientlistOptionObj.text;
                    if (userClientNameStr) {
                    var userClientNameObj = userClientNameStr.replace(/'/g, "''");
                    userClientName = "'" + userClientNameObj + "'";
                    if (userClientName == "'MULTIPLE'") {
                        var userClientName1 = window.localStorage.getItem('userclientNames');
                        userClientName = userClientName1;
                    } else if (userClientName == "'ALL'") {
                        userClientName = "";
                    } else if (userClientName == "''") {
                        userClientName = "'-1'";
                    }
                }
                }

                var businessflow = this.SummarySelectOptionObj.text;
                await axios({
                        timeout:60000,
                        method: 'POST',
                        url: apiUrl.api_url + 'getCSAWStatusSummary',
                        datatype: 'json',
                        data: {
                            fdate: date,
                            userid: userReporting,
                            userDepartmentId: userDepartmentId,
                            businessflow: businessflow,
                            hubId: hubId,
                            userClientName: userClientName
                        },
                        headers: commonFunction.getusertoken(),
                    })
                    .then(result => {
                        this.CSAWStatusSummaryLoading = false;
                        let resultDataCrm = result.data.data;
                        if (resultDataCrm.status) {
                            let resultData = result.data.data.data;

                            this.chartCSAWOptions.series = [];
                            this.chartCSAWOptions.totalcount = 0;
                            this.chartCSAWOptions.totalcount = resultData.length;

                            for (let i = 0; i < resultData.length; i++) {
                                var dataValue = [];
                                dataValue.push(parseInt(resultData[i].totalcount));
                                var csawele = {
                                    name: resultData[i].notificationstatus,
                                    data: dataValue
                                }

                                this.chartCSAWOptions.series.push(csawele);
                            }

                        } else {
                            let msg = resultDataCrm.msg;
                          //  this.$alertify.error(msg);
                        }
                    }, error => {
                        this.CSAWStatusSummaryLoading = false;
                        var commonVariable = commonFunction.showNetworkError(error);
                       // this.$alertify.error(commonVariable);
                    });
            } catch (error) {
                this.CSAWStatusSummaryLoading = false;
                let msg = error + " - getCSAWStatusSummary";
               // this.$alertify.error(msg);
            }
        },

        async selectHub(dataObj) {
            try {
                this.isLoading = true;
                this.HubSelectOptionObj = dataObj;
                this.clearValues();
                await this.getTicketsSummery_Enquiry_Request_Complaint1();

                await this.getCancellationReasons();
                await this.getMTDReattempt();
                await this.getMTDEscalation();
                await this.getCSAWStatusSummary();
                await this.getMTDFakeResoneTicket();
                await this.getFakeResoneTicket();
                if (this.InboundMainDiv) {
                    this.getTwitterTickets();
                }
                await this.getTop_5_Locations_Complaint();
                await this.getTop_5_Locations_Escalation();
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - selectHub";
                this.$alertify.error(msg);
            }
        },
        async clientList() {
            try {

                this.clientlistObj = [];
                var clientList = JSON.parse(window.localStorage.getItem(
                    "userclientList"
                ));

             //   console.log("clientList "+JSON.stringify(clientList));

                if (clientList.length > 0) {

                    if (clientList[0].CompanyName != "ALL") {
                        this.clientlistOptionObj = {};
                        this.clientlistOptionObj = {
                            value: "0",
                            text: "MULTIPLE"
                        };
                        this.clientlistObj.push(this.clientlistOptionObj);
                    }

                    for (let i = 0; i < clientList.length; i++) {
                        this.clientlistOptionObj = {};
                        this.clientlistOptionObj = {
                            value: clientList[i].ClientMasterID,
                            text: clientList[i].CompanyName
                        };
                        this.clientlistObj.push(this.clientlistOptionObj);
                    }

                    if (clientList[0].CompanyName == "ALL") {
                        this.clientlistOptionObj = {};
                        this.clientlistOptionObj = {
                            value: "0",
                            text: "ALL"
                        };
                    } else {
                        this.clientlistOptionObj = {};
                        this.clientlistOptionObj = {
                            value: "0",
                            text: "MULTIPLE"
                        };
                    }

                } else {
                    this.clientListButton = false;
                    this.clientListSpan = true;
                }

            } catch (error) {
                let msg = error + " - clientList";
                this.$alertify.error(msg);
            }
        },
        async selectClient(dataObj) {
            try {
                this.isLoading = true;
                this.clientlistOptionObj = dataObj;
                this.clearValues();
                await this.getTicketsSummery_Enquiry_Request_Complaint1();
                await this.getCancellationReasons();
                await this.getMTDReattempt();
                await this.getMTDEscalation();
                await this.getCSAWStatusSummary();
                await this.getMTDFakeResoneTicket();
                await this.getFakeResoneTicket();
                if (this.InboundMainDiv) {
                    this.getTwitterTickets();
                }
                await this.getTop_5_Locations_Complaint();
                await this.getTop_5_Locations_Escalation();
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                let msg = error + " - selectClient";
                this.$alertify.error(msg);
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/views/components/b2b/b2bdashboard/b2bdashboard.component.js